import React, { useEffect, useState } from "react";

import { groupBy, sumBy } from "lodash";
import { useMemo } from "react";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import moment from "moment";

import Logo_Original from "../image/Logo_Original.png";
import Google from "../image/Google.png";

import { Col, Row } from "antd";
import { useCountry, useCurrency } from "../../provider/courtryProvider";
import { makeStyles } from "@material-ui/core";
const color = {
  color: "black",
};
const useStyles = makeStyles((theme) => {
  return {
    invoiceContainer: {
      "& .ant-col": {
        fontFamily: theme.props.Fonttype
          ? `${theme.props.Fonttype} !important`
          : "'Besmoke', sans-serif !important",
      },
    },
  };
});

const orderType = {
  dine_in: "Dine In",
  parcel: "Parcel",
  delivery: "Delivery",
};

const ReturnProducts = ({ products }) => {
  const filtered = useMemo(() => {
    return products.filter((i) => parseInt(i.returned));
  }, [products]);
  return (
    <div>
      <div>Returned Items</div>
      <div>
        <Row>
          <Col span={16}>ITEM NAME</Col>
          <Col span={8}>QUANTITY</Col>

          <div className="dash"></div>

          {filtered.map((i) => {
            return (
              <>
                <Col span={16}>{i.productName}</Col>
                <Col
                  style={{
                    textAlign: "center",
                  }}
                  span={8}
                >
                  {i.returned}
                </Col>
              </>
            );
          })}
        </Row>
      </div>
      <div className="dash"></div>
    </div>
  );
};

const InvoiceTemplate = React.forwardRef(({ data }, ref) => {
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  console.log("data11", data);
  const currencyFormatter = useCurrency();
  const country = useCountry();
  const styles = useStyles(invoiceSettings);
  var a = [
    "",
    "One ",
    "Two ",
    "Three ",
    "Four ",
    "Five ",
    "Six ",
    "Seven ",
    "Eight ",
    "Nine ",
    "Ten ",
    "Eleven ",
    "Twelve ",
    "Thirteen ",
    "Fourteen ",
    "Fifteen ",
    "Sixteen ",
    "Seventeen ",
    "Eighteen ",
    "Nineteen ",
  ];
  var b = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];

  const printerType = invoiceSettings.printerType;
  const thermalPapertype = invoiceSettings.thermalPapertype;

  const A4design = invoiceSettings.A4design;
  console.log("A4design", A4design);
  const shopDetails = data.shopDetails;

  const settings = data.settings;

  const result = data.result;

  const products = data.products;
  const discountType = data.discountType;
  const billInput = data.billInput;
  const customerDetails = data.customerDetails;
  const loyaltyPoints = data.loyaltyPoints;
  const couponObj = data.couponObj;
  const loyaltyObj = data.loyaltyObj;
  const currentDate = moment().format("DD-MM-YYYY");

  console.log("shopDetailsLoyalty", shopDetails.loyaltyPackage);

  const calculateAmountSaved = (data) => {
    let totalMrp = 0;
    let totalPrice = 0;
    data.map((data) => {
      if (
        data.productMrp !== "" &&
        parseFloat(data.productPrice) < parseFloat(data.productMrp)
      ) {
        totalMrp += parseFloat(data.productMrp || 0) * parseFloat(data.count);
        totalPrice += parseFloat(data.itemTotal);
      }
    });
    return (totalMrp - totalPrice).toFixed(2);
  };

  const getTotalGST = (data) => {
    let totalGST = sumBy(data, (o) => {
      return o.gst;
    });
    return totalGST;
  };

  const getTotalCESS = (data) => {
    let totalCess = sumBy(data, (o) => {
      return o.cess;
    });
    return totalCess;
  };

  const getTotalAddCess = (data) => {
    let totalAddCess = sumBy(data, (o) => {
      return o.additionalcess;
    });
    return totalAddCess;
  };
  const getTotalIgst = (data) => {
    let totalIgst = sumBy(data, (o) => {
      return o.igst;
    });
    return totalIgst;
  };
  const paymentMethodGenerator = (data) => {
    console.log("paymentDataReceived", data);
    if (Array.isArray(data)) {
      //   var temp = data.map((data) => {
      //     return data.method;
      //   });
      //   console.log("temp.toString()",temp.toString());
      return data.toString();
    } else {
      return data;
    }
  };

  const productTaxCalc = useMemo(() => {
    if (invoiceSettings.itemleveltax) {
      const taxs = groupBy(products, function (obj) {
        if (parseFloat(obj?.totalTax) !== 0) {
          return obj.totalTax;
        } else if (obj.tax !== "0") {
          return obj.tax;
        }
      });
      const keys = Object.keys(taxs);
      const filterKeys = keys.filter((key) => {
        let result;
        if (key !== "undefined" && key !== "0" && key !== 0) {
          result = key;
        }
        return result;
      });
      let availableTaxType = [];
      const result = filterKeys?.map((i) => {
        const taxTypesValues = {};
        taxs[i].forEach((product) => {
          product.taxType.forEach((type) => {
            taxTypesValues[type] = (taxTypesValues[type] || 0) + product[type];
          });
          availableTaxType.push(...product.taxType);
        });
        const totoltaxableValue = sumBy(taxs[i], function (i) {
          return parseFloat(i.taxableValue);
        });
        return {
          taxPercentage: i,
          taxableValue: totoltaxableValue,
          taxType: Object.keys(taxTypesValues),
          ...taxTypesValues,
        };
      });
      const splitGST = result?.map((i) => {
        return {
          ...i,
          cgst: i.gst / 2,
          sgst: i.gst / 2,
        };
      });
      let head = [];
      const tempHead = [...new Set(availableTaxType)];
      tempHead.forEach((x) => {
        if (x === "gst") {
          head.push("cgst", "sgst");
        } else {
          head.push(x);
        }
      });

      head = head.map((i) => {
        const label = customTaxType.find((type) => type.taxName === i)?.label;
        return label || i;
      });

      return {
        data: splitGST,
        head: head,
      };
    } else {
      return {
        data: [],
        head: [],
      };
    }
  }, [products, invoiceSettings.itemleveltax, customTaxType]);

  console.log("productTaxCalc", productTaxCalc);

  const inWords = (num) => {
    let n;
    if ((num = Math.floor(num).toString()).length > 9) return "overflow";
    n = ("000000000" + num)
      .substr(-9)
      .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = "";
    str +=
      n[1] != 0
        ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
        : "";
    str +=
      n[2] != 0
        ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
        : "";
    str +=
      n[3] != 0
        ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
        : "";
    str +=
      n[4] != 0
        ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
        : "";
    str +=
      n[5] != 0
        ? (str != "" ? "and " : "") +
          (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
          " "
        : "";
    return str;
  };
  const types = {
    dine_in: "Dine In",
    delivery: "Delivery",
    parcel: "Parcel",
  };

  const getUpdatedLoyaltyPoints = (billAmount, oldPoint) => {
    const loyaltyRatio = shopDetails.loyaltyAmount;
    const loyaltyPointPerRatio = shopDetails.loyaltyPoints;

    const result =
      (parseFloat(billAmount) / parseFloat(loyaltyRatio)) *
      loyaltyPointPerRatio;

    console.log("loyaltyRatio", loyaltyRatio, loyaltyPointPerRatio, result);

    return result + parseFloat(oldPoint);
  };

  // console.log("currentLoyaltyPoints", data.deliveryAddress);

  if (printerType === "Thermal" || "") {
    if (thermalPapertype === "80" || "") {
      return (
        <div>
          <div className="THERMAL-container4 3">
            <div className="THERMAL-menu-left">
              <div
                className="THERMAL-menu-template"
                style={{ display: "none" }}
              >
                {/* style={{display:"none"}} */}
                <div
                  className="design360 Thermal-design"
                  style={{ width: "400px" }}
                >
                  <div
                    className={`root ${styles.invoiceContainer}`}
                    ref={ref}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "column",
                      maxWidth: "400px",
                      fontFamily: invoiceSettings.Fonttype
                        ? invoiceSettings.Fonttype
                        : "'Besmoke', sans-serif",
                      textTransform: "capitalize",
                      paddingBottom: "10px",
                      fontWeight: 400,
                      color: "#000",
                      letterSpacing: "0px",
                      fontSize: invoiceSettings.T80fontsize
                        ? invoiceSettings.T80fontsize
                        : "14px",
                    }}
                  >
                    <div className="Thermal-header">
                      <div className="Thermal-header-top">
                        {/* <div>{shopDetails.shopIconLocation}</div> */}
                        <div
                          style={{
                            marginTop: "4px",

                            align: "center",
                            fontWeight: "700",
                            lineHeight: "15px",
                            overflowWrap: "break-word",
                          }}
                        >
                          {/* {invoiceSettings.shoplogo ? (
                            <img
                              src={shopDetails.shopIconLocation}
                              alt="shop icon"
                              style={{
                                width: "56px",
                                height: "56px",
                                paddingLeft: "5px",
                                borderRadius: "12px",
                              }}
                            />
                          ) : null} */}
                          {shopDetails.shopName}
                        </div>
                        <div style={{ margin: "0px", padding: "0px" }}>
                          <div>
                            <div style={{ overflowWrap: "break-word" }}>
                              {invoiceSettings.ShopAddress && (
                                <div style={{ overflowWrap: "break-word" }}>
                                  {shopDetails.shopAddress}
                                </div>
                              )}
                            </div>
                            <div
                              style={{
                                margin: "0px",
                                padding: "0px",
                                overflowWrap: "break-word",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: invoiceSettings.T80fontsize
                                    ? invoiceSettings.T80fontsize
                                    : "14px",
                                  overflowWrap: "break-word",
                                }}
                              >
                                {shopDetails.websiteContactPhoneNumber
                                  ? shopDetails.websiteContactPhoneNumber
                                  : shopDetails.shopPhoneNumber}
                              </div>
                            </div>
                          </div>
                          {shopDetails.websiteUrl && (
                            <div>
                              {invoiceSettings.ShopURL && (
                                <div style={{ overflowWrap: "break-word" }}>
                                  {shopDetails.customDomainUrl
                                    ? shopDetails.customDomainUrl
                                    : shopDetails.websiteUrl}
                                </div>
                              )}
                            </div>
                          )}
                          {shopDetails.shopGST && (
                            <div>
                              <div style={{ overflowWrap: "break-word" }}>
                                {shopDetails.shopGST}
                              </div>
                            </div>
                          )}
                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: "600",
                              textTransform: "uppercase",
                            }}
                          >
                            {paymentMethodGenerator(data.paymentMethod)} SALES
                          </div>
                          {shopDetails.shopType === "Restaurant" && (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "600",
                                textTransform: "uppercase",
                              }}
                            >
                              {orderType[data.orderType]}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="dash"></div>

                      <div
                        className=" design80 Thermal-header-bottom"
                        style={{ marginTop: "5px" }}
                      >
                        <div className="Thermal-header-bottom-left">
                          <div
                            style={{
                              margin: "0px",
                              padding: "0px",
                              // textAlign: "center",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                }}
                              >
                                Invoice No:
                                {invoiceSettings.invoiceprefix && (
                                  <span>{result.invoicePrefixField}</span>
                                )}
                                {result.invoiceNumber}
                              </div>
                            </div>
                            {customerDetails.customerName !== "" &&
                              customerDetails.customerName !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                      }}
                                    >
                                      Name:{customerDetails.customerName}
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                        <div
                          className="Thermal-header-bottom-right"
                          style={{ wordBreak: "break-word" }}
                        >
                          <div>
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                }}
                              >
                                Date:{currentDate}
                              </div>
                            </div>
                            {customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                      }}
                                    >
                                      Mobile:
                                      {customerDetails.customerPhoneNumber}
                                    </div>
                                  )}
                                  {shopDetails.employeeName && (
                                    <div
                                      style={{
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                      }}
                                    >
                                      Billed By:{shopDetails.employeeName}
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="dash" style={{ margin: "4px 0" }}></div>
                    </div>
                    <div
                      className="Thermal-Body"
                      style={{
                        fontSize: invoiceSettings.T80fontsize
                          ? invoiceSettings.T80fontsize
                          : "14px",
                      }}
                    >
                      <div
                        className="Thermal-body-first"
                        style={{ fontWeight: 500 }}
                      >
                        <div className="holder" style={{}}>
                          <div>
                            {/* <div className="item"  style={{width:'350px',textAlign:"left" }}>ITEM Name</div> */}
                          </div>
                          <div>
                            <div
                              className="item1"
                              style={{
                                textAlign: "left",
                                width: "115px",
                                fontWeight: 600,
                              }}
                            >
                              ITEM NAME
                            </div>
                          </div>
                          {invoiceSettings.itemmrp ? (
                            <div className="item1" style={{ fontWeight: 600 }}>
                              MRP
                            </div>
                          ) : null}

                          <div className="item1" style={{ fontWeight: 600 }}>
                            RATE
                          </div>
                          <div className="item1" style={{ fontWeight: 600 }}>
                            QTY
                          </div>

                          {invoiceSettings.itemdiscount ? (
                            <div className="item1" style={{ fontWeight: 600 }}>
                              DISC
                            </div>
                          ) : null}
                          {invoiceSettings.hsncode ? (
                            <div className="item1" style={{ fontWeight: 600 }}>
                              HSN
                            </div>
                          ) : null}
                          {invoiceSettings.itemleveltax ? (
                            <div className="item1" style={{ fontWeight: 600 }}>
                              TAX(%)
                            </div>
                          ) : null}

                          {shopDetails.shopType === "Mobile" &&
                          invoiceSettings.imei1imei2 ? (
                            <div className="item1" style={{ fontWeight: 600 }}>
                              IMEI
                            </div>
                          ) : null}
                          <div
                            className="item1"
                            style={{
                              textAlign: "right",
                              marginLeft: "auto",
                              fontWeight: 600,
                            }}
                          >
                            AMOUNT
                          </div>
                        </div>
                        <div className="dash" style={{ margin: "4px 0" }}></div>

                        {products.map((data, i) => (
                          <>
                            {parseFloat(data.itemTotal) !== 0 && (
                              <div style={{ fontWeight: "500" }} key={i}>
                                <div className="holder">
                                  <div
                                    className="item1"
                                    style={{
                                      width: "115px",
                                      textAlign: "left",
                                      overflowWrap: "break-word",
                                      wordBreak: "break-all",
                                      lineHeight: "16px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {data.productName}
                                  </div>
                                  {invoiceSettings.itemmrp ? (
                                    <div
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                      className="item1"
                                    >
                                      {data.productMrp ? data.productMrp : "-"}
                                    </div>
                                  ) : null}

                                  <div
                                    className="item1"
                                    style={{
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {parseFloat(data.productPrice)}
                                  </div>
                                  <div
                                    style={{
                                      overflowWrap: "break-word",
                                    }}
                                    className="item1"
                                  >
                                    {parseFloat(data.count)}
                                  </div>
                                  {invoiceSettings.itemdiscount ? (
                                    <div
                                      className="item1"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.discountPrice
                                        ? data.discountPrice
                                        : "-"}
                                      {data.discountType === "percentage"
                                        ? "%"
                                        : ""}
                                    </div>
                                  ) : null}
                                  {invoiceSettings.hsncode ? (
                                    <div
                                      className="item1"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.productHsnCode
                                        ? data.productHsnCode
                                        : "-"}
                                    </div>
                                  ) : null}
                                  {invoiceSettings.itemleveltax ? (
                                    <div
                                      className="item1"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.totalTax
                                        ? parseFloat(data.totalTax)
                                        : data.tax
                                        ? parseFloat(data.tax)
                                        : "-"}
                                    </div>
                                  ) : null}
                                  {shopDetails.shopType === "Mobile" && (
                                    <div>
                                      {" "}
                                      {invoiceSettings.imei1imei2 ? (
                                        <div
                                          className="item1"
                                          style={{
                                            overflowWrap: "break-word",

                                            textAlign: "center",
                                          }}
                                        >
                                          {data?.imei1
                                            ? data?.imei1
                                            : data?.imei2
                                            ? data?.imei2
                                            : "-"}
                                        </div>
                                      ) : null}
                                    </div>
                                  )}
                                  <div
                                    className="item1"
                                    style={{
                                      overflowWrap: "break-word",
                                      textAlign: "right",
                                      marginLeft: "auto",
                                    }}
                                  >
                                    {data.itemTotal
                                      ? parseFloat(data.itemTotal).toFixed(2)
                                      : parseFloat(data.productPrice) *
                                        parseFloat(data.count)}
                                  </div>
                                </div>
                                {/* <div
                                  className="dash"
                                  style={{
                                    margin: "2px 0",
                                  }}
                                /> */}
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                      <div
                        className="dash"
                        style={{
                          margin: "4px 0",
                        }}
                      />

                      <div
                        className="Thermal-body-second"
                        style={{
                          fontWeight: 500,
                          marginTop: "-4px",
                          paddingInline: "10px",
                        }}
                      >
                        <div>
                          <Row>
                            <Col
                              span={17}
                              className="columnData"
                              // style={{ letterSpacing: "-1px" }}
                            >
                              Sub Total
                            </Col>
                            <Col
                              span={7}
                              className="columnData1"
                              style={{
                                overflowWrap: "break-word",
                              }}
                            >
                              {currencyFormatter(result.billSubTotal)}
                            </Col>
                          </Row>
                          {data.loyaltyDiscount > 0 && (
                            <Row>
                              <Col span={16} className="columnData">
                                Loyalty Discount
                              </Col>
                              <Col
                                span={8}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                  fontFamily: "inherit",
                                }}
                              >
                                -{currencyFormatter(data.loyaltyDiscount)}
                              </Col>
                            </Row>
                          )}
                          {Boolean(
                            invoiceSettings.roundOff &&
                              Math.abs(result.roundOffAmount) > 0
                          ) && (
                            <Row>
                              <Col
                                span={17}
                                className="columnData"
                                // style={{ letterSpacing: "-1px" }}
                              >
                                Round Off
                              </Col>
                              <Col
                                span={7}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                }}
                              >
                                {currencyFormatter(result.roundOffAmount)}
                              </Col>
                            </Row>
                          )}
                          {invoiceSettings.othercharges &&
                            settings.otherChargesField?.length > 0 &&
                            settings?.otherChargesField?.map((data) => {
                              if (parseFloat(data.price)) {
                                return (
                                  <Row key={data.id}>
                                    <Col
                                      span={17}
                                      className="columnData"
                                      // style={{ letterSpacing: "-1px" }}
                                    >
                                      Other charges({" "}
                                      {data.name.charAt(0).toUpperCase() +
                                        data.name.slice(1)}
                                      )
                                    </Col>
                                    <Col
                                      span={7}
                                      className="columnData1"
                                      style={{
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {data.price
                                        ? currencyFormatter(data.price)
                                        : ""}
                                    </Col>
                                  </Row>
                                );
                              }
                            })}

                          {Boolean(
                            invoiceSettings.adddiscount &&
                              billInput.billDiscount
                          ) && (
                            <Row>
                              <Col
                                span={17}
                                className="columnData"
                                // style={{ letterSpacing: "-1px" }}
                              >
                                Discount(Flat)
                              </Col>
                              <Col
                                span={7}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                }}
                              >
                                {country.CurrencySymbol}
                                {discountType.billDiscountType === "flat"
                                  ? billInput.billDiscount
                                    ? billInput.billDiscount
                                    : "0"
                                  : discountType.billDiscountType ===
                                    "percentage"
                                  ? parseFloat(
                                      (result.billSubTotal *
                                        billInput.billDiscount) /
                                        100
                                    ).toFixed(1)
                                  : " "}
                              </Col>
                            </Row>
                          )}

                          {Object.keys(couponObj).length > 0 && (
                            <Row>
                              <Col
                                span={17}
                                className="columnData"
                                // style={{ letterSpacing: "-1px" }}
                              >
                                Coupon Code
                              </Col>
                              <Col
                                span={7}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                  // letterSpacing: "-1px",
                                }}
                              >
                                {parseFloat(
                                  result.couponDiscountAmount
                                ).toFixed(2)}
                              </Col>
                            </Row>
                          )}

                          {customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA" &&
                            invoiceSettings.customerprivacy && (
                              <div>
                                {Object.keys(loyaltyObj).length > 0 && (
                                  <Row>
                                    <Col
                                      span={17}
                                      className="columnData"
                                      // style={{ letterSpacing: "-1px" }}
                                    >
                                      Loyalty Discount(Points)
                                    </Col>
                                    <Col
                                      span={7}
                                      className="columnData1"
                                      style={{
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      -{loyaltyObj.minLoyaltyPointsReq}
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            )}

                          <Row>
                            <Col
                              span={14}
                              // style={{ letterSpacing: "-1px" }}
                              className="columnData"
                              style={{
                                fontWeight: "600",
                                fontSize: 22,
                              }}
                            >
                              Total Amount
                            </Col>
                            <Col
                              span={10}
                              className="columnData1"
                              style={{
                                overflowWrap: "break-word",
                                fontWeight: "600",
                                fontSize: 22,
                              }}
                            >
                              {currencyFormatter(result.billFinalTotal)}
                            </Col>
                          </Row>
                        </div>

                        {/* <div className="dash"></div> */}

                        <div
                          className="Thermal-body-details"
                          style={{
                            // display: "flex",
                            marginTop: "5px",
                            gap: "5px",
                          }}
                        >
                          <Row style={{ textAlign: "left" }}>
                            <Col
                              span={24}
                              style={{
                                textAlign: "left",
                                paddingLeft: 10,
                              }}
                            >
                              Total Item count: {products.length}
                            </Col>
                          </Row>
                          <strong>
                            <div>Total(in words):</div>
                          </strong>
                          <div
                            style={{
                              overflowWrap: "break-word",
                            }}
                          >
                            {inWords(result.billFinalTotal)}Only
                          </div>
                        </div>
                        {/* <div className="dash"></div> */}

                        {(calculateAmountSaved(products) > 0 ||
                          (customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA")) && (
                          <div
                            style={{
                              // display: "flex",

                              width: "100%",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <Row style={{ width: "100%" }}>
                                <Col span={24}>
                                  {" "}
                                  {customerDetails.customerPhoneNumber !== "" &&
                                    customerDetails.customerPhoneNumber !==
                                      "NA" &&
                                    invoiceSettings.customerprivacy && (
                                      <div
                                        style={{
                                          display: "flex",
                                          // flexDirection: "row",
                                          // width: "50%",
                                          fontWeight: "700",
                                        }}
                                      >
                                        {shopDetails.loyaltyPackage ===
                                          "yes" && (
                                          <Row gutter={[8, 8]}>
                                            <Col
                                              span={12}
                                              style={{
                                                textAlign: "left",
                                                overflowWrap: "break-word",
                                                fontWeight: "700",
                                                whiteSpace: "nowrap",
                                                letterSpacing: "-1px",
                                                fontFamily: "inherit",
                                                paddingLeft: 12,
                                              }}
                                            >
                                              Loyalty:
                                            </Col>
                                            <Col
                                              span={12}
                                              style={{
                                                overflowWrap: "break-word",
                                                textAlign: "right",
                                                fontWeight: "700",
                                                letterSpacing: "-1px",
                                                fontFamily: "inherit",
                                              }}
                                            >
                                              {loyaltyObj.minLoyaltyPointsReq
                                                ? (
                                                    parseFloat(
                                                      getUpdatedLoyaltyPoints(
                                                        result.billFinalTotal,
                                                        loyaltyPoints
                                                          ? loyaltyPoints
                                                          : 0
                                                      )
                                                    ) -
                                                    parseFloat(
                                                      loyaltyObj.minLoyaltyPointsReq
                                                    )
                                                  ).toFixed(2)
                                                : getUpdatedLoyaltyPoints(
                                                    result.billFinalTotal,
                                                    loyaltyPoints
                                                      ? loyaltyPoints
                                                      : 0
                                                  ).toFixed(2)}
                                            </Col>
                                          </Row>
                                        )}
                                      </div>
                                    )}{" "}
                                </Col>
                              </Row>
                            </div>
                            <div style={{ width: "100%" }}>
                              {invoiceSettings.itemmrp && (
                                <div>
                                  {calculateAmountSaved(products) > 0 && (
                                    <>
                                      <div
                                        style={{
                                          marginInline: "-8px",
                                        }}
                                        className="dash"
                                      ></div>
                                      <div
                                        style={{
                                          // flexDirection: "row",
                                          // width: "50%",
                                          fontWeight: "700",
                                          fontSize: "24px",
                                        }}
                                      >
                                        <Row style={{ marginTop: "2px" }}>
                                          <Col
                                            span={13}
                                            style={{
                                              textAlign: "center",
                                              overflowWrap: "break-word",
                                              fontWeight: "700",
                                              letterSpacing: "-1px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontFamily:
                                                  invoiceSettings.Fonttype
                                                    ? invoiceSettings.Fonttype
                                                    : "'Besmoke', sans-serif",
                                                fontSize: 18,
                                              }}
                                            >
                                              Saved Amount
                                            </span>
                                          </Col>
                                          <Col
                                            span={11}
                                            style={{
                                              textAlign: "center",
                                              overflowWrap: "break-word",
                                              fontWeight: "700",
                                              fontSize: 18,
                                            }}
                                          >
                                            {currencyFormatter(
                                              calculateAmountSaved(products)
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* <div className="dash"></div> */}

                        <div
                          className="dash"
                          style={{
                            marginInline: "-8px",
                          }}
                        ></div>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <div style={{ width: "48%" }}>
                            <Row style={{ width: "100%" }}>
                              <Col
                                span={8}
                                style={{
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  fontWeight: "700",

                                  whiteSpace: "nowrap",
                                  fontFamily: "inherit",
                                  color: "#000",
                                  paddingLeft: 10,
                                }}
                              >
                                Paid:
                              </Col>
                              <Col
                                span={16}
                                style={{
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  fontWeight: "700",
                                  fontFamily: "inherit",
                                  color: "#000",
                                }}
                              >
                                {currencyFormatter(billInput.billPaid)}
                              </Col>
                            </Row>
                          </div>
                          <div style={{ width: "58%" }}>
                            {billInput.billAmountDue < 0 && (
                              <Row>
                                <Col
                                  span={13}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                    fontWeight: "700",

                                    fontFamily: "inherit",
                                    whiteSpace: "nowrap",
                                    color: "#000",
                                  }}
                                >
                                  Balance :
                                </Col>
                                <Col
                                  span={11}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                    fontWeight: "700",
                                    color: "#333333",
                                    fontFamily: "inherit",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </Col>
                              </Row>
                            )}
                            {billInput.billAmountDue > 0 && (
                              <Row>
                                <Col
                                  span={10}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "left",
                                    fontWeight: "600",
                                    whiteSpace: "nowrap",
                                    fontFamily: "inherit",
                                  }}
                                >
                                  Due Amount:
                                </Col>
                                <Col
                                  span={14}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "center",
                                    fontWeight: "600",
                                    fontFamily: "inherit",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="dash" style={{ margin: "4px 0" }}></div>

                      {invoiceSettings.itemleveltax &&
                        productTaxCalc?.data.length > 0 && (
                          <>
                            {invoiceSettings.itemleveltax &&
                              productTaxCalc?.data?.length > 0 && (
                                <div>
                                  <div class="table-row header">
                                    <div
                                      style={{
                                        textAlign: "left",
                                      }}
                                      className="num-80"
                                    >
                                      Desc
                                    </div>
                                    <div
                                      style={{
                                        textAlign: "left",
                                      }}
                                      className="taxable"
                                    >
                                      Taxable
                                    </div>
                                    {productTaxCalc?.head.map((head, i) => (
                                      <div
                                        style={{
                                          textAlign: "left",
                                          textTransform: "capitalize",
                                        }}
                                        className="num-80"
                                      >
                                        {head === "additionalcess"
                                          ? "Ad.Cess"
                                          : head}
                                      </div>
                                    ))}
                                  </div>
                                  {productTaxCalc?.data.map((data, i) => (
                                    <div key={i} className="table-row">
                                      <div
                                        style={{
                                          textAlign: "left",
                                          fontWeight: "500",
                                        }}
                                        className="num-80"
                                      >
                                        {data.taxPercentage
                                          ? parseFloat(
                                              data.taxPercentage
                                            ).toFixed(1)
                                          : 0.0}
                                        %
                                      </div>
                                      <div
                                        className="taxable"
                                        style={{
                                          textAlign: "left",
                                          fontWeight: "500",
                                        }}
                                      >
                                        {parseFloat(data.taxableValue).toFixed(
                                          2
                                        )}
                                      </div>
                                      {productTaxCalc?.head.map((head, i) => (
                                        <div
                                          style={{
                                            textAlign: "left",
                                            textTransform: "capitalize",
                                          }}
                                          className="num-80"
                                        >
                                          {data[head]
                                            ? parseFloat(data[head]).toFixed(2)
                                            : "-"}
                                        </div>
                                      ))}
                                    </div>
                                  ))}
                                  <div className="dash"></div>
                                </div>
                              )}
                          </>
                        )}
                      {data.billReturn && (
                        <ReturnProducts products={products} />
                      )}
                    </div>

                    <div className="Thermal-Footer">
                      {invoiceSettings.deliveryaddress ? (
                        <div>
                          {data.deliveryAddress !== "" &&
                          data.deliveryAddress !== "NA" ? (
                            <div>
                              <strong>
                                <div
                                  style={{
                                    fontWeight: "600",
                                    marginTop: "5px",
                                  }}
                                >
                                  Delivery Address:
                                </div>
                              </strong>

                              <div style={{ overflowWrap: "break-word" }}>
                                {data.deliveryAddress}
                              </div>
                              <div
                                className="dash"
                                style={{
                                  margin: "4px 0",
                                }}
                              />
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {invoiceSettings.termscondition ? (
                        <div>
                          {invoiceSettings.tAndCField !== "" &&
                          invoiceSettings.tAndCField !== "NA" ? (
                            <div>
                              <div style={{ fontWeight: "600" }}>
                                Terms and Condition:
                              </div>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  fontWeight: "400",
                                }}
                              >
                                {invoiceSettings.tAndCField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {invoiceSettings.paymenyterms ? (
                        <div>
                          {invoiceSettings.paymentTermsField !== "" &&
                          invoiceSettings.paymentTermsField !== "NA" ? (
                            <div>
                              <div style={{ fontWeight: "600" }}>
                                Payment terms:
                              </div>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  fontWeight: "400",
                                }}
                              >
                                {invoiceSettings.paymentTermsField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}

                      {/* {invoiceSettings.invoiceprefix ? (
                        <div>
                          {invoiceSettings.invoicePrefixtext !== "" &&
                          invoiceSettings.invoicePrefixtext !== "NA" ? (
                            <div style={{ display: "flex" }}>
                              <div style={{ overflowWrap: "break-word" }}>
                                Invoice-Prefix:
                              </div>
                              <div
                                style={{
                                  fontWeight: "lighter",
                                  overflowWrap: "break-word",
                                }}
                              >
                                 {result.invoicePrefixField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null} */}

                      {!!(invoiceSettings.notes && billInput.notes) && (
                        <div style={{ display: "flex" }}>
                          <div style={{ overflowWrap: "break-word" }}>
                            <b>Notes: </b>
                            <div
                              style={{
                                fontWeight: "lighter",
                                overflowWrap: "break-word",
                              }}
                            >
                              {billInput.notes}
                            </div>
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          textAlign: "center",

                          fontWeight: "400",
                          letterSpacing: "0.05",
                          color: "#000000",
                          margin: "0px",
                        }}
                      >
                        *****Thank you for shopping!!!*****
                      </div>
                      <div>
                        {invoiceSettings.QRCode && (
                          <div style={{ textAlign: "center", margin: "0px" }}>
                            {shopDetails.customDomainUrl ? (
                              <QRCode
                                value={shopDetails.customDomainUrl}
                                size={60}
                              />
                            ) : (
                              <QRCode
                                value={
                                  "https://play.google.com/store/apps/details?id=com.ghoshak_owner"
                                }
                                size={80}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="THERMAL-container4 3">
            <div className="THERMAL-menu-left">
              <div
                className="THERMAL-menu-template"
                style={{ display: "none" }}
              >
                {/* style={{display:"none"}} */}
                <div
                  className={`design360 Thermal-design ${styles.invoiceContainer}`}
                  style={{ width: "270px" }}
                >
                  <div
                    className="root"
                    ref={ref}
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                      flexDirection: "column",
                      maxWidth: "270px",
                      fontFamily: invoiceSettings.Fonttype
                        ? invoiceSettings.Fonttype
                        : "'Besmoke', sans-serif",
                      textTransform: "capitalize",
                      paddingBottom: "10px",
                      fontWeight: 400,
                      color: "#000",
                      letterSpacing: "0px",
                      fontSize: invoiceSettings.T55fontsize
                        ? invoiceSettings.T55fontsize
                        : "12px",
                    }}
                  >
                    <div className="Thermal-header">
                      <div className="Thermal58-header-top">
                        {/* <div>{shopDetails.shopIconLocation}</div> */}
                        <div
                          style={{
                            marginTop: "4px",
                            // fontSize: "14px",
                            align: "center",
                            fontWeight: "700",
                            lineHeight: "15px",
                            overflowWrap: "break-word",
                          }}
                        >
                          {shopDetails.shopName}
                        </div>
                        <div style={{ margin: "0px", padding: "0px" }}>
                          <div>
                            {invoiceSettings.ShopAddress && (
                              <div style={{ overflowWrap: "break-word" }}>
                                {shopDetails.shopAddress}
                              </div>
                            )}
                            <div
                              style={{
                                margin: "0px",
                                padding: "0px",
                              }}
                            >
                              <div style={{ overflowWrap: "break-word" }}>
                                {shopDetails.websiteContactPhoneNumber
                                  ? shopDetails.websiteContactPhoneNumber
                                  : shopDetails.shopPhoneNumber}
                              </div>
                            </div>
                          </div>
                          {shopDetails.websiteUrl && (
                            <div>
                              {invoiceSettings.ShopURL && (
                                <div style={{ overflowWrap: "break-word" }}>
                                  {shopDetails.customDomainUrl
                                    ? shopDetails.customDomainUrl
                                    : shopDetails.websiteUrl}
                                </div>
                              )}
                            </div>
                          )}
                          {shopDetails.shopGST && (
                            <div>
                              <div style={{ overflowWrap: "break-word" }}>
                                {shopDetails.shopGST}
                              </div>
                            </div>
                          )}
                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: "600",
                              textTransform: "uppercase",
                            }}
                          >
                            {paymentMethodGenerator(data.paymentMethod)} SALES
                          </div>
                          {shopDetails.shopType === "Restaurant" && (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "600",
                                textTransform: "uppercase",
                              }}
                            >
                              {orderType[data.orderType]}
                            </div>
                          )}
                        </div>
                        <div
                          className="dash"
                          style={{
                            margin: "4px 0",
                          }}
                        />
                      </div>

                      <div
                        className="Thermal-header-bottom thermal58"
                        style={{ marginTop: "5px" }}
                      >
                        <div
                          className="Thermal58-header-bottom-left"
                          style={{ width: "50%" }}
                        >
                          <div
                            style={{
                              margin: "0px",
                              padding: "0px",
                              // textAlign: "center",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  letterSpacing: "-1px",
                                }}
                              >
                                Inv:
                                {invoiceSettings.invoiceprefix && (
                                  <span>{result.invoicePrefixField}</span>
                                )}
                                {result.invoiceNumber}
                              </div>
                            </div>
                            {customerDetails.customerName !== "" &&
                              customerDetails.customerName !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                        letterSpacing: "-1px",
                                      }}
                                    >
                                      Name:{customerDetails.customerName}
                                    </div>
                                  )}
                                </div>
                              )}
                          </div>
                        </div>
                        <div
                          className="Thermal58-header-bottom-right"
                          style={{ width: "50%" }}
                        >
                          <div style={{ textAlign: "right" }}>
                            <div>
                              <div
                                style={{
                                  fontWeight: "500",
                                  textAlign: "left",
                                  letterSpacing: "-1px",
                                }}
                              >
                                Date:{currentDate}
                              </div>
                            </div>
                            {customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                        textAlign: "left",
                                        letterSpacing: "-1px",
                                      }}
                                    >
                                      Mobile:
                                      {customerDetails.customerPhoneNumber}
                                    </div>
                                  )}
                                </div>
                              )}
                            {shopDetails.employeeName && (
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  letterSpacing: "-1px",
                                }}
                              >
                                Billed By:{shopDetails.employeeName}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="dash"
                        style={{
                          margin: "4px 0",
                        }}
                      />
                    </div>
                    <div
                      className="Thermal-Body"
                      style={{
                        fontSize: invoiceSettings.T55fontsize
                          ? invoiceSettings.T55fontsize
                          : "12px",
                      }}
                    >
                      <div className="Thermal58 Thermal-body-first">
                        <div className="holder">
                          <div className="item" style={{ textAlign: "left" }}>
                            ITEM
                          </div>
                          {invoiceSettings.itemmrp ? (
                            <div className="item">MRP</div>
                          ) : null}
                          <div className="item">RATE</div>
                          <div className="item">QTY</div>

                          {invoiceSettings.itemdiscount ? (
                            <div className="item">DISC</div>
                          ) : null}
                          {invoiceSettings.hsncode ? (
                            <div className="item">HSN</div>
                          ) : null}
                          {invoiceSettings.itemleveltax ? (
                            <div className="item">TAX(%)</div>
                          ) : null}
                          {shopDetails.shopType === "Mobile" && (
                            <div>
                              {" "}
                              {invoiceSettings.imei1imei2 ? (
                                <div className="item">IMEI</div>
                              ) : null}{" "}
                            </div>
                          )}
                          <div
                            className="item"
                            style={{ textAlign: "right", marginLeft: "auto" }}
                          >
                            AMOUNT
                          </div>
                        </div>

                        <div
                          className="dash"
                          style={{
                            margin: "4px 0",
                          }}
                        ></div>
                        {products.map((data, i) => (
                          <>
                            {parseFloat(data.itemTotal) !== 0 && (
                              <div
                                style={{ fontWeight: "500", margin: "4px 0" }}
                                key={i}
                              >
                                <div className="holder">
                                  <div
                                    className="item"
                                    style={{
                                      textAlign: "left",
                                      overflowWrap: "break-word",
                                      wordBreak: "break-all",
                                      lineHeight: "15px",
                                    }}
                                  >
                                    <strong>{data.productName}</strong>
                                  </div>
                                  {invoiceSettings.itemmrp ? (
                                    <div
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                      className="item"
                                    >
                                      {data.productMrp ? data.productMrp : "-"}
                                    </div>
                                  ) : null}
                                  <div
                                    className="item"
                                    style={{
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {parseFloat(data.productPrice)}
                                  </div>
                                  <div
                                    style={{
                                      overflowWrap: "break-word",
                                    }}
                                    className="item"
                                  >
                                    {parseFloat(data.count)}
                                  </div>

                                  {invoiceSettings.itemdiscount ? (
                                    <div
                                      className="item"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.discountPrice
                                        ? data.discountPrice
                                        : "-"}
                                      {data.discountType === "percentage"
                                        ? "%"
                                        : ""}
                                    </div>
                                  ) : null}
                                  {invoiceSettings.hsncode ? (
                                    <div
                                      className="item"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.productHsnCode
                                        ? data.productHsnCode
                                        : "-"}
                                    </div>
                                  ) : null}
                                  {invoiceSettings.itemleveltax ? (
                                    <div
                                      className="item"
                                      style={{
                                        overflowWrap: "break-word",

                                        textAlign: "center",
                                      }}
                                    >
                                      {data.totalTax
                                        ? parseFloat(data.totalTax)
                                        : data.tax
                                        ? parseFloat(data.tax)
                                        : "-"}
                                    </div>
                                  ) : null}
                                  {shopDetails.shopType === "Mobile" && (
                                    <div>
                                      {" "}
                                      {invoiceSettings.imei1imei2 ? (
                                        <div
                                          className="item"
                                          style={{
                                            overflowWrap: "break-word",

                                            textAlign: "center",
                                          }}
                                        >
                                          {data?.imei1
                                            ? data?.imei1
                                            : data?.imei2
                                            ? data?.imei2
                                            : "-"}
                                        </div>
                                      ) : null}{" "}
                                    </div>
                                  )}
                                  <div
                                    className="item"
                                    style={{
                                      overflowWrap: "break-word",
                                      textAlign: "right",
                                      marginLeft: "auto",
                                    }}
                                  >
                                    {data.itemTotal
                                      ? parseFloat(data.itemTotal).toFixed(2)
                                      : parseFloat(data.productPrice) *
                                        parseFloat(data.count)}
                                  </div>
                                </div>

                                {/* <div
                                  className="dash"
                                  style={{ margin: "2px 0" }}
                                ></div> */}
                              </div>
                            )}
                          </>
                        ))}
                      </div>
                      <div
                        className="dash"
                        style={{
                          margin: "4px 0",
                        }}
                      />

                      <div
                        className="Thermal-body-second"
                        style={{
                          fontWeight: 500,
                          marginTop: "-4px",
                          letterSpacing: "-1px",
                        }}
                      >
                        <div
                          style={{
                            paddingInline: "8px",
                            paddingInlineEnd: "12px",
                          }}
                        >
                          <Row>
                            <Col span={16} className="columnData">
                              Sub Total
                            </Col>
                            <Col
                              span={8}
                              className="columnData1"
                              style={{
                                overflowWrap: "break-word",
                                fontFamily: "inherit",
                              }}
                            >
                              {currencyFormatter(result.billSubTotal)}
                            </Col>
                          </Row>
                          {data.loyaltyDiscount > 0 && (
                            <Row>
                              <Col span={16} className="columnData">
                                Loyalty Discount
                              </Col>
                              <Col
                                span={8}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                  fontFamily: "inherit",
                                }}
                              >
                                {currencyFormatter(data.loyaltyDiscount)}
                              </Col>
                            </Row>
                          )}
                          {Boolean(
                            invoiceSettings.roundOff &&
                              Math.abs(result.roundOffAmount) > 0
                          ) && (
                            <Row>
                              <Col
                                span={17}
                                className="columnData"
                                // style={{ letterSpacing: "-1px" }}
                              >
                                Round Off
                              </Col>
                              <Col
                                span={7}
                                className="columnData1"
                                style={{
                                  overflowWrap: "break-word",
                                }}
                              >
                                {currencyFormatter(result.roundOffAmount)}
                              </Col>
                            </Row>
                          )}

                          {Boolean(
                            invoiceSettings.adddiscount &&
                              billInput.billDiscount
                          ) && (
                            <Row>
                              <Col span={16} className="columnData">
                                Discount(
                                {discountType.billDiscountType === "flat"
                                  ? "Flat"
                                  : "Percentage"}
                                )
                              </Col>

                              <Col
                                span={8}
                                className="columnData1"
                                style={{ overflowWrap: "break-word" }}
                              >
                                {country.CurrencySymbol}
                                {discountType.billDiscountType === "flat"
                                  ? billInput.billDiscount
                                    ? billInput.billDiscount
                                    : "0"
                                  : discountType.billDiscountType ===
                                    "percentage"
                                  ? parseFloat(
                                      (result.billSubTotal *
                                        billInput.billDiscount) /
                                        100
                                    ).toFixed(1)
                                  : " "}
                              </Col>
                            </Row>
                          )}

                          {Object.keys(couponObj).length > 0 && (
                            <Row>
                              <Col span={16} className="columnData">
                                Coupon Code
                              </Col>
                              <Col
                                span={8}
                                className="columnData1"
                                style={{ overflowWrap: "break-word" }}
                              >
                                {parseFloat(
                                  result.couponDiscountAmount
                                ).toFixed(2)}
                              </Col>
                            </Row>
                          )}

                          {invoiceSettings.othercharges &&
                            settings.otherChargesField?.length > 0 &&
                            settings?.otherChargesField?.map((data) => {
                              if (parseFloat(data.price)) {
                                return (
                                  <Row key={data.id}>
                                    <Col span={16} className="columnData">
                                      Other charges({" "}
                                      {data.name.charAt(0).toUpperCase() +
                                        data.name.slice(1)}
                                      )
                                    </Col>
                                    <Col
                                      span={8}
                                      className="columnData1"
                                      style={{
                                        overflowWrap: "break-word",
                                        fontFamily: "inherit",
                                      }}
                                    >
                                      {data.price
                                        ? currencyFormatter(data.price)
                                        : ""}
                                    </Col>
                                  </Row>
                                );
                              }
                            })}

                          {customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA" &&
                            invoiceSettings.customerprivacy && (
                              <div>
                                {Object.keys(loyaltyObj).length > 0 && (
                                  <Row>
                                    <Col span={18} className="columnData">
                                      Loyalty Discount(Points)
                                    </Col>
                                    <Col
                                      span={6}
                                      className="columnData1"
                                      style={{ overflowWrap: "break-word" }}
                                    >
                                      {loyaltyObj.minLoyaltyPointsReq}
                                    </Col>
                                  </Row>
                                )}
                              </div>
                            )}

                          <Row>
                            <Col
                              span={14}
                              style={{
                                fontWeight: "600",
                                fontSize: 22,
                              }}
                              className="columnData"
                            >
                              Total Amount
                            </Col>
                            <Col
                              span={10}
                              className="columnData1"
                              style={{
                                overflowWrap: "break-word",
                                fontWeight: "600",
                                fontSize: 22,
                              }}
                            >
                              {currencyFormatter(result.billFinalTotal)}
                            </Col>
                          </Row>
                        </div>

                        {/* <div className="dash"></div> */}

                        <div
                          className="Thermal-body-details"
                          style={{
                            // display: "flex",
                            marginTop: "5px",
                            gap: "5px",
                          }}
                        >
                          <Row style={{ textAlign: "left" }}>
                            <Col
                              span={24}
                              style={{ textAlign: "left", paddingLeft: 12 }}
                            >
                              Total Item count:{products.length}
                            </Col>
                          </Row>
                          <strong>
                            <div style={{ letterSpacing: "0px" }}>
                              Total(in words):
                            </div>
                          </strong>
                          <div style={{ overflowWrap: "break-word" }}>
                            {inWords(result.billFinalTotal)}Only
                          </div>
                        </div>
                        {/* <div className="dash"></div> */}

                        {(calculateAmountSaved(products) > 0 ||
                          (customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA")) && (
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <Row style={{ width: "100%" }}>
                                {shopDetails.loyaltyPackage === "yes" && (
                                  <Col span={24}>
                                    {" "}
                                    {customerDetails.customerPhoneNumber !==
                                      "" &&
                                      customerDetails.customerPhoneNumber !==
                                        "NA" &&
                                      invoiceSettings.customerprivacy && (
                                        <div
                                          style={{
                                            display: "flex",
                                            // flexDirection: "row",
                                            // width: "50%",
                                            fontWeight: "700",
                                          }}
                                        >
                                          {shopDetails.loyaltyPackage ===
                                            "yes" && (
                                            <Row gutter={16}>
                                              <Col
                                                span={13}
                                                style={{
                                                  textAlign: "left",
                                                  overflowWrap: "break-word",
                                                  fontWeight: "700",
                                                  whiteSpace: "nowrap",
                                                  letterSpacing: "-1px",
                                                  paddingLeft: 25,
                                                }}
                                              >
                                                Loyalty:{"  "}
                                              </Col>
                                              <Col
                                                span={11}
                                                style={{
                                                  overflowWrap: "break-word",
                                                  textAlign: "center",
                                                  fontWeight: "700",
                                                  letterSpacing: "-1px",
                                                }}
                                              >
                                                {loyaltyObj.minLoyaltyPointsReq
                                                  ? (
                                                      parseFloat(
                                                        getUpdatedLoyaltyPoints(
                                                          result.billFinalTotal,
                                                          loyaltyPoints
                                                            ? loyaltyPoints
                                                            : 0
                                                        )
                                                      ) -
                                                      parseFloat(
                                                        loyaltyObj.minLoyaltyPointsReq
                                                      )
                                                    ).toFixed(2)
                                                  : getUpdatedLoyaltyPoints(
                                                      result.billFinalTotal,
                                                      loyaltyPoints
                                                        ? loyaltyPoints
                                                        : 0
                                                    ).toFixed(2)}
                                              </Col>
                                            </Row>
                                          )}
                                        </div>
                                      )}
                                  </Col>
                                )}
                              </Row>
                            </div>
                            <div style={{ width: "100%" }}>
                              {invoiceSettings.itemmrp && (
                                <div>
                                  {calculateAmountSaved(products) > 0 && (
                                    <>
                                      <div
                                        className="dash"
                                        style={{
                                          marginInline: "-8px",
                                        }}
                                      ></div>
                                      <div
                                        style={{
                                          // flexDirection: "row",
                                          // width: "50%",
                                          fontWeight: "700",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <Row style={{ marginTop: "2px" }}>
                                          <Col
                                            span={15}
                                            style={{
                                              textAlign: "center",
                                              overflowWrap: "break-word",
                                              fontWeight: "700",
                                              letterSpacing: "-1px",
                                            }}
                                          >
                                            <span
                                              style={{
                                                fontFamily:
                                                  invoiceSettings.Fonttype
                                                    ? invoiceSettings.Fonttype
                                                    : "'Besmoke', sans-serif",
                                                fontSize: 18,
                                              }}
                                            >
                                              Saved Amount
                                            </span>
                                          </Col>
                                          <Col
                                            span={9}
                                            style={{
                                              textAlign: "left",
                                              overflowWrap: "break-word",
                                              fontWeight: "700",
                                              letterSpacing: "-1px",
                                              fontSize: 18,
                                            }}
                                          >
                                            {currencyFormatter(
                                              calculateAmountSaved(products)
                                            )}
                                          </Col>
                                        </Row>
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        )}

                        {/* <div className="dash"></div> */}

                        <div
                          className="dash"
                          style={{ marginInline: "-8px" }}
                        ></div>
                        <div
                          style={{
                            display: "flex",
                            width: "100%",
                          }}
                        >
                          <div style={{ width: "48%" }}>
                            <Row style={{ width: "100%" }}>
                              <Col
                                span={8}
                                style={{
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  fontWeight: "700",

                                  whiteSpace: "nowrap",
                                  letterSpacing: "0px",
                                  color: "#000",
                                  paddingLeft: 10,
                                }}
                              >
                                Paid:
                              </Col>
                              <Col
                                span={16}
                                style={{
                                  overflowWrap: "break-word",
                                  textAlign: "left",
                                  fontWeight: "700",
                                  letterSpacing: "0px",
                                  color: "#000",
                                }}
                              >
                                {currencyFormatter(billInput.billPaid)}
                              </Col>
                            </Row>
                          </div>
                          <div style={{ width: "52%" }}>
                            {billInput.billAmountDue < 0 && (
                              <Row>
                                <Col
                                  span={12}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "left",
                                    fontWeight: "700",

                                    whiteSpace: "nowrap",
                                    letterSpacing: "0px",
                                    color: "#000",
                                  }}
                                >
                                  Balance:
                                </Col>
                                <Col
                                  span={12}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "left",
                                    fontWeight: "700",
                                    color: "#000",
                                    letterSpacing: "0px",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </Col>
                              </Row>
                            )}
                            {billInput.billAmountDue > 0 && (
                              <Row>
                                <Col
                                  span={13}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "right",
                                    fontWeight: "700",
                                    whiteSpace: "nowrap",
                                    letterSpacing: "0px",
                                  }}
                                >
                                  Due Amount:
                                </Col>
                                <Col
                                  span={11}
                                  style={{
                                    overflowWrap: "break-word",
                                    textAlign: "right",
                                    fontWeight: "700",
                                    letterSpacing: "0px",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </Col>
                              </Row>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="dash" style={{ margin: "5px 0" }}></div>

                      {invoiceSettings.itemleveltax &&
                        productTaxCalc?.data?.length > 0 && (
                          <>
                            {invoiceSettings.itemleveltax &&
                              productTaxCalc?.data?.length > 0 && (
                                <div>
                                  <div class="table-row header">
                                    <div
                                      style={{
                                        textAlign: "left",
                                      }}
                                      className="num-80"
                                    >
                                      Desc
                                    </div>
                                    <div
                                      style={{
                                        textAlign: "left",
                                      }}
                                      className="taxable"
                                    >
                                      Taxable
                                    </div>
                                    {productTaxCalc?.head.map((head, i) => (
                                      <div
                                        style={{
                                          textAlign: "left",
                                          textTransform: "capitalize",
                                        }}
                                        className="num-80"
                                      >
                                        {head === "additionalcess"
                                          ? "Ad.Cess"
                                          : head}
                                      </div>
                                    ))}
                                  </div>
                                  {productTaxCalc?.data.map((data, i) => (
                                    <div key={i} className="table-row">
                                      {productTaxCalc?.data?.map((data, i) => (
                                        <div key={i} className="table-row">
                                          <div
                                            style={{
                                              textAlign: "left",
                                              fontWeight: "500",
                                            }}
                                            className="num-80"
                                          >
                                            {data.taxPercentage
                                              ? parseFloat(
                                                  data.taxPercentage
                                                ).toFixed(1)
                                              : 0.0}
                                            %
                                          </div>
                                          <div
                                            className="taxable"
                                            style={{
                                              textAlign: "left",
                                              fontWeight: "500",
                                            }}
                                          >
                                            {parseFloat(
                                              data.taxableValue
                                            ).toFixed(2)}
                                          </div>
                                          {productTaxCalc?.head.map(
                                            (head, i) => (
                                              <div
                                                style={{
                                                  textAlign: "left",
                                                  textTransform: "capitalize",
                                                }}
                                                className="num-80"
                                              >
                                                {data[head]
                                                  ? parseFloat(
                                                      data[head]
                                                    ).toFixed(2)
                                                  : "-"}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  ))}
                                  <div
                                    className="dash"
                                    style={{
                                      margin: "4px 0",
                                    }}
                                  />
                                </div>
                              )}
                          </>
                        )}
                      {data.billReturn && (
                        <ReturnProducts products={products} />
                      )}
                    </div>
                    {/* <div className="dash"></div> */}
                    <div className="Thermal-Footer" style={{ margin: "5px" }}>
                      {invoiceSettings.deliveryaddress ? (
                        <div>
                          {data.deliveryAddress !== "" &&
                          data.deliveryAddress !== "NA" ? (
                            <div>
                              <strong>
                                <div style={{ fontWeight: "600" }}>
                                  Delivery Address:
                                </div>
                              </strong>

                              <div style={{ overflowWrap: "break-word" }}>
                                {data.deliveryAddress}
                              </div>
                              <div className="dash"></div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {invoiceSettings.termscondition ? (
                        <div>
                          {invoiceSettings.tAndCField !== "" &&
                          invoiceSettings.tAndCField !== "NA" ? (
                            <div>
                              <div style={{ fontWeight: "600" }}>
                                Terms and Condition:
                              </div>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  fontWeight: "400",
                                }}
                              >
                                {invoiceSettings.tAndCField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {invoiceSettings.paymenyterms ? (
                        <div>
                          {invoiceSettings.paymentTermsField !== "" &&
                          invoiceSettings.paymentTermsField !== "NA" ? (
                            <div>
                              <div style={{ fontWeight: "600" }}>
                                Payment terms:
                              </div>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  fontWeight: "400",
                                }}
                              >
                                {invoiceSettings.paymentTermsField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null}

                      {/* {invoiceSettings.invoiceprefix ? (
                        <div>
                          {invoiceSettings.invoicePrefixtext !== "" &&
                          invoiceSettings.invoicePrefixtext !== "NA" ? (
                            <div style={{ display: "flex" }}>
                              <div style={{ overflowWrap: "break-word" }}>
                                Invoice-Prefix:
                              </div>
                              <div
                                style={{
                                  fontWeight: "lighter",
                                  overflowWrap: "break-word",
                                }}
                              >
                                 {result.invoicePrefixField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null} */}

                      {!!(invoiceSettings.notes && billInput.notes) && (
                        <div style={{ display: "flex" }}>
                          <div style={{ overflowWrap: "break-word" }}>
                            <b>Notes: </b>
                            <div
                              style={{
                                fontWeight: "lighter",
                                overflowWrap: "break-word",
                              }}
                            >
                              {billInput.notes}
                            </div>
                          </div>
                        </div>
                      )}

                      <div
                        style={{
                          textAlign: "center",

                          fontWeight: "400",
                          letterSpacing: "0.05",
                          color: "#000000",
                          margin: "0px",
                        }}
                      >
                        *****Thank you for shopping!!!*****
                      </div>
                      <div>
                        {invoiceSettings.QRCode && (
                          <div style={{ textAlign: "center", margin: "0px" }}>
                            {shopDetails.customDomainUrl ? (
                              <QRCode
                                value={shopDetails.customDomainUrl}
                                size={60}
                              />
                            ) : (
                              <QRCode
                                value={
                                  "https://play.google.com/store/apps/details?id=com.ghoshak_owner"
                                }
                                size={80}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  } else {
    if (A4design === "Classic") {
      return (
        <div id="test1212">
          <div
            className="INVOICE-SIDEBAR-menu-template"
            style={{ height: "auto", display: "none" }}
          >
            {/* ,display:"none" */}

            <div
              id="divToPrint"
              ref={ref}
              className="chapter"
              style={{ backgroundColor: "white" }}
            >
              <div className="Classic-A4-design">
                <div
                  className="Classic-Header"
                  style={{
                    fontSize: invoiceSettings.A4fontsize,
                    fontFamily: invoiceSettings.A4Fonttype,
                  }}
                >
                  <div className="Classic-Header-left">
                    <div className="Classic-Header-left-top">
                      <div>
                        <strong>Invoice No</strong>
                      </div>
                      <div>
                        {invoiceSettings.invoiceprefix && (
                          <span>{result.invoicePrefixField}</span>
                        )}
                        {result.invoiceNumber}
                      </div>
                    </div>
                    {(customerDetails.customerName ||
                      customerDetails.customerPhoneNumber ||
                      data.billingAddress !== "") &&
                    (customerDetails.customerName ||
                      customerDetails.customerPhoneNumber ||
                      data.billingAddress !== "NA") ? (
                      <div>
                        {invoiceSettings.customerprivacy && (
                          <div className="Classic-Header-left-mid">
                            {(customerDetails.customerName &&
                              customerDetails.customerName != "NA") ||
                              (customerDetails.customerPhoneNumber &&
                                customerDetails.customerPhoneNumber != "NA") ||
                              (data.billingAddress &&
                                data.billingAddress != "NA" && (
                                  <div style={{ fontWeight: "600" }}>
                                    Invoice To.
                                  </div>
                                ))}

                            {customerDetails.customerName !== "" &&
                              customerDetails.customerName !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {customerDetails.customerName}
                                    </div>
                                  )}
                                </div>
                              )}
                            {customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div
                                      style={{
                                        fontWeight: "500",
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {customerDetails.customerPhoneNumber}
                                    </div>
                                  )}
                                </div>
                              )}
                            {invoiceSettings.deliveryaddress && (
                              <div>
                                {data.billingAddress !== "" &&
                                data.billingAddress !== "NA" ? (
                                  <div
                                    style={{
                                      inlineHeight: "0.5px",
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {data.billingAddress}
                                  </div>
                                ) : null}
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ) : null}
                    <div className="Classic-Header-left-bot">
                      <div style={{ paddingBottom: "2px" }}>
                        <div>
                          <strong>Invoice Date:</strong>
                          {currentDate}
                        </div>
                        <div></div>
                      </div>
                      <div>
                        {/* {invoiceSettings.duedate &&(<div>Due Date:</div>)} 
             {invoiceSettings.duedate&&(<div>25-Aug-2001</div>)} */}
                        {shopDetails.employeeName && (
                          <div
                            style={{
                              textAlign: "left",
                              marginBottom: "2px",
                              overflowWrap: "break-word",
                              color: "black",
                            }}
                          >
                            <strong>Billed by:</strong>{" "}
                            {shopDetails.employeeName}
                          </div>
                        )}
                        <div
                          style={{
                            display: "flex",
                            overflowWrap: "break-word",
                          }}
                        >
                          <div>
                            <strong>Payment Mode:</strong>
                            {paymentMethodGenerator(data.paymentMethod)}
                          </div>
                        </div>
                        {shopDetails.shopType === "Restaurant" && (
                          <div
                            style={{
                              textAlign: "center",
                              fontWeight: "600",
                              textTransform: "uppercase",
                            }}
                          >
                            {orderType[data.orderType]}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="Classic-Header-right">
                    <div style={{ marginTop: "20px" }}>
                      {invoiceSettings.shoplogo && (
                        <div style={{ padding: "5px" }}>
                          {shopDetails.shopIconLocation !== "removed" &&
                            shopDetails.shopIconLocation !== "" && (
                              <img
                                src={shopDetails.shopIconLocation}
                                alt="shop logo"
                                style={{
                                  width: "95px",
                                  height: "95px",
                                  padding: "2px",
                                }}
                              />
                            )}
                        </div>
                      )}
                      <div
                        className="Classic-Header-right-title"
                        style={{
                          color: invoiceSettings.color,
                          fontSize: "34px",
                        }}
                      >
                        {shopDetails.shopName}
                      </div>
                      <div
                        className="Classic-header-right-content"
                        style={{ height: "auto" }}
                      >
                        {shopDetails.websiteUrl && (
                          <div>
                            {invoiceSettings.ShopURL && (
                              <div>
                                {shopDetails.customDomainUrl
                                  ? shopDetails.customDomainUrl
                                  : shopDetails.websiteUrl}
                              </div>
                            )}
                          </div>
                        )}
                        {shopDetails.shopGST && (
                          <div> {shopDetails.shopGST}</div>
                        )}
                        <div>
                          Mobile:
                          {shopDetails.websiteContactPhoneNumber
                            ? shopDetails.websiteContactPhoneNumber
                            : shopDetails.shopPhoneNumber}
                        </div>
                        {invoiceSettings.ShopAddress && (
                          <div> {shopDetails.shopAddress}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="Classic-Body"
                  style={{
                    fontSize: invoiceSettings.A4fontsize,
                    fontFamily: invoiceSettings.A4Fonttype,
                  }}
                >
                  <div className="Classic-Body-top">
                    <table style={{ width: "100%", height: "110px" }}>
                      <thead style={{ height: "30px" }}>
                        <tr style={{ textAlign: "center" }}>
                          <th
                            style={{ backgroundColor: invoiceSettings.color }}
                          >
                            S.no
                          </th>

                          <th
                            style={{ backgroundColor: invoiceSettings.color }}
                          >
                            Items
                          </th>
                          {invoiceSettings.itemmrp ? (
                            <th
                              style={{ backgroundColor: invoiceSettings.color }}
                            >
                              MRP
                            </th>
                          ) : null}

                          <th
                            style={{ backgroundColor: invoiceSettings.color }}
                          >
                            Rate
                          </th>
                          <th
                            style={{ backgroundColor: invoiceSettings.color }}
                          >
                            Qty
                          </th>
                          {invoiceSettings.itemdiscount ? (
                            <th
                              style={{ backgroundColor: invoiceSettings.color }}
                            >
                              Disc
                            </th>
                          ) : null}
                          {invoiceSettings.hsncode ? (
                            <th
                              style={{ backgroundColor: invoiceSettings.color }}
                            >
                              HSN
                            </th>
                          ) : null}
                          {invoiceSettings.itemleveltax ? (
                            <th
                              style={{ backgroundColor: invoiceSettings.color }}
                            >
                              Tax(%)
                            </th>
                          ) : null}
                          {shopDetails.shopType === "Mobile" &&
                            invoiceSettings.imei1imei2 && (
                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                IMEI1/IMEI2
                              </th>
                            )}

                          <th
                            style={{ backgroundColor: invoiceSettings.color }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {products.map((data, i) => (
                          <>
                            {parseFloat(data.itemTotal) !== 0 && (
                              <tr key={i}>
                                <td>{i + 1}</td>

                                <td style={{ textAlign: "left" }}>
                                  {" "}
                                  {invoiceSettings.variant ? (
                                    <>
                                      {data.productName}-{data.unitOfMeasurment}
                                    </>
                                  ) : (
                                    <>{data.productName}</>
                                  )}{" "}
                                </td>
                                {invoiceSettings.itemmrp ? (
                                  <td>
                                    {" "}
                                    {data.productMrp
                                      ? data.productMrp
                                      : "-"}{" "}
                                  </td>
                                ) : null}
                                <td> {parseFloat(data.productPrice)}</td>
                                <td>{parseFloat(data.count)}</td>

                                {invoiceSettings.itemdiscount ? (
                                  <td>
                                    {data.discountPrice
                                      ? data.discountPrice
                                      : "-"}
                                    {data.discountType === "percentage"
                                      ? "%"
                                      : ""}
                                  </td>
                                ) : null}
                                {invoiceSettings.hsncode ? (
                                  <td>
                                    {data.productHsnCode
                                      ? data.productHsnCode
                                      : "-"}
                                  </td>
                                ) : null}
                                {invoiceSettings.itemleveltax ? (
                                  <td>
                                    {" "}
                                    {data.totalTax
                                      ? parseFloat(data.totalTax)
                                      : data.tax
                                      ? parseFloat(data.tax)
                                      : "-"}
                                  </td>
                                ) : null}
                                {shopDetails.shopType === "Mobile" &&
                                invoiceSettings.imei1imei2 ? (
                                  <td>
                                    {data?.imei1
                                      ? data?.imei1
                                      : data?.imei2
                                      ? data?.imei2
                                      : "-"}
                                  </td>
                                ) : null}

                                <td>
                                  {data.itemTotal
                                    ? parseFloat(data.itemTotal).toFixed(2)
                                    : parseFloat(data.productPrice) *
                                      parseFloat(data.count)}
                                </td>
                              </tr>
                            )}
                          </>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div
                    className="Classic-Body-bot"
                    style={{
                      fontSize: invoiceSettings.A4fontsize,
                      fontFamily: invoiceSettings.A4Fonttype,
                    }}
                  >
                    <div className="Classic-body-bot-left">
                      <div className="Classic-body-bot-left-content">
                        {!!(invoiceSettings.notes && billInput.notes) && (
                          <div style={{ display: "flex" }}>
                            <div style={{ overflowWrap: "break-word" }}>
                              <b>Notes: </b>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                }}
                              >
                                {billInput.notes}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="Classic-body-bot-left-content">
                        {invoiceSettings.termscondition && (
                          <div>
                            {invoiceSettings.tAndCField !== "" ? (
                              <div style={{ fontWeight: "600" }}>
                                Terms and Conditions:
                              </div>
                            ) : null}
                          </div>
                        )}
                        {invoiceSettings.termscondition && (
                          <div style={{ overflowWrap: "break-word" }}>
                            {invoiceSettings.tAndCField}
                          </div>
                        )}
                        {invoiceSettings.paymenyterms && (
                          <div>
                            {invoiceSettings.paymentTermsField !== "" ? (
                              <div className="Classic-body-bot-left-content">
                                {invoiceSettings.paymentTermsField ? (
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      overflowWrap: "break-word",
                                      color: "black",
                                    }}
                                  >
                                    Payment Terms:
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        )}
                        {invoiceSettings.paymenyterms && (
                          <div
                            style={{
                              overflowWrap: "break-word",
                              color: "black",
                            }}
                          >
                            {invoiceSettings.paymentTermsField}{" "}
                          </div>
                        )}
                      </div>
                      {invoiceSettings.deliveryaddress && (
                        <div>
                          {data.deliveryAddress !== "" &&
                          data.deliveryAddress !== "NA" ? (
                            <div className="Classic-body-bot-left-content">
                              <div
                                style={{ fontWeight: "600", color: "black" }}
                              >
                                Delivery To:
                              </div>
                              <div
                                style={{
                                  overflowWrap: "break-word",
                                  color: "black",
                                }}
                              >
                                {data.deliveryAddress}{" "}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      )}
                      {/* {invoiceSettings.invoiceprefix ? (
                      <div>
                        {invoiceSettings.invoicePrefixtext !== "" ? (
                          <div className="Classic-body-bot-left-content">
                            <div>
                              <strong>Invoice-Prefix: </strong>
                               {result.invoicePrefixField}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    ) : null} */}
                    </div>
                    <div className="Classic-body-bot-right">
                      <div className="Classic-body-bot-righ-top">
                        <div>
                          <div
                            style={{
                              // marginLeft: "70px",
                              textAlign: "left",

                              // width: "52%",
                              marginLeft: "70px",
                              backgroundColor: "#F3F3F3",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "2px 0",
                              }}
                            >
                              {/* <span>Items: {products.length}</span> */}
                              <span>SUB Total</span>
                              <span>
                                {currencyFormatter(result.billSubTotal)}
                              </span>
                            </div>
                            {data.loyaltyDiscount > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "2px 0",
                                }}
                              >
                                {/* <span>Items: {products.length}</span> */}
                                <span>Loyalty Discount</span>
                                <span>
                                  - {currencyFormatter(data.loyaltyDiscount)}
                                </span>
                              </div>
                            )}
                            {Boolean(
                              invoiceSettings.roundOff &&
                                Math.abs(result.roundOffAmount) > 0
                            ) && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "2px 0",
                                }}
                              >
                                {/* <span>Items: {products.length}</span> */}
                                <span>Round Off</span>
                                <span>
                                  {currencyFormatter(result.roundOffAmount)}
                                </span>
                              </div>
                            )}
                            {Boolean(
                              invoiceSettings.adddiscount &&
                                billInput.billDiscount
                            ) && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                  }}
                                >
                                  <span> Discount(Flat)</span>
                                  <span>
                                    {country.CurrencySymbol}
                                    {discountType.billDiscountType === "flat"
                                      ? billInput.billDiscount
                                        ? billInput.billDiscount
                                        : "0"
                                      : discountType.billDiscountType ===
                                        "percentage"
                                      ? parseFloat(
                                          (result.billSubTotal *
                                            billInput.billDiscount) /
                                            100
                                        ).toFixed(1)
                                      : 0}
                                  </span>
                                </div>
                              </>
                            )}
                            {Object.keys(couponObj).length > 0 && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                  }}
                                >
                                  <span>COUPON DISC</span>
                                  <span>
                                    {parseFloat(
                                      result.couponDiscountAmount
                                    ).toFixed(2)}
                                  </span>
                                </div>

                                <div className="dash" style={{}} />
                              </>
                            )}
                            {invoiceSettings.othercharges &&
                              settings.otherChargesField?.length > 0 &&
                              settings?.otherChargesField?.map((data) => {
                                if (parseFloat(data.price)) {
                                  return (
                                    <div key={data.id}>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "2px 0",
                                        }}
                                        key={data.id}
                                      >
                                        <div>
                                          Other charges(
                                          {data.name.charAt(0).toUpperCase() +
                                            data.name.slice(1)}
                                          )
                                        </div>
                                        <div>
                                          {data.price
                                            ? currencyFormatter(data.price)
                                            : ""}
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            {customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" && (
                                <div>
                                  {invoiceSettings.customerprivacy && (
                                    <div>
                                      {Object.keys(loyaltyObj).length > 0 && (
                                        <>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              padding: "2px 0",
                                            }}
                                          >
                                            <span
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {" "}
                                              Loyalty Discount(Points)
                                            </span>
                                            <span
                                              style={{
                                                overflowWrap: "break-word",
                                              }}
                                            >
                                              {loyaltyObj.minLoyaltyPointsReq}
                                            </span>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "2px 0",
                                fontWeight: 600,
                                fontSize: 22,
                              }}
                            >
                              <span>Total Amount</span>
                              <span>
                                {currencyFormatter(result.billFinalTotal)}
                              </span>
                            </div>
                            {invoiceSettings.itemmrp && (
                              <div>
                                {calculateAmountSaved(products) > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                    }}
                                  >
                                    <div style={{ fontWeight: "600" }}>
                                      Saved Amount
                                    </div>
                                    <div
                                      style={{
                                        fontWeight: "600",
                                        fontSize: 18,
                                      }}
                                    >
                                      {currencyFormatter(
                                        calculateAmountSaved(products)
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "2px 0",
                                color: "#000",
                              }}
                            >
                              <div>Amount Paid:</div>
                              <div>{currencyFormatter(billInput.billPaid)}</div>
                            </div>

                            {billInput.billAmountDue < 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "2px 0",
                                  color: "#000",
                                }}
                              >
                                <div>Balance Amount:</div>
                                <div>
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </div>
                              </div>
                            )}
                            {billInput.billAmountDue > 0 && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "2px 0",
                                }}
                              >
                                <div>Amount Due:</div>
                                <div>
                                  <strong>
                                    {currencyFormatter(
                                      Math.abs(billInput.billAmountDue)
                                    )}
                                  </strong>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="Classic-body-bot-righ-bot">
                        {customerDetails.customerPhoneNumber !== "" &&
                          customerDetails.customerPhoneNumber !== "NA" &&
                          invoiceSettings.customerprivacy && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "2px 0",
                                overflowWrap: "break-word",
                              }}
                            >
                              <strong>Loyalty Pts:</strong>
                              <div>
                                {loyaltyObj.minLoyaltyPointsReq
                                  ? (
                                      parseFloat(
                                        getUpdatedLoyaltyPoints(
                                          result.billFinalTotal,
                                          loyaltyPoints ? loyaltyPoints : 0
                                        )
                                      ) -
                                      parseFloat(loyaltyObj.minLoyaltyPointsReq)
                                    ).toFixed(2)
                                  : getUpdatedLoyaltyPoints(
                                      result.billFinalTotal,
                                      loyaltyPoints ? loyaltyPoints : 0
                                    ).toFixed(2)}
                              </div>
                            </div>
                          )}

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "2px 0",
                            overflowWrap: "break-word",
                          }}
                        >
                          <strong>Total in Words:</strong>
                          <div style={{ overflowWrap: "break-word" }}>
                            {inWords(result.billFinalTotal)}Only
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "50%" }}>
                  {invoiceSettings.itemleveltax &&
                    productTaxCalc.data?.length > 0 && (
                      <div style={{ border: "" }}>
                        <div
                          class="table-row header"
                          style={{ border: "none" }}
                        >
                          <div
                            style={{
                              textAlign: "left",
                            }}
                            className="num-80"
                          >
                            Desc
                          </div>
                          <div
                            style={{
                              textAlign: "left",
                            }}
                            className="taxable"
                          >
                            Taxable
                          </div>
                          {productTaxCalc?.head.map((head, i) => (
                            <div
                              style={{
                                textAlign: "left",
                                textTransform: "capitalize",
                              }}
                              className="num-80"
                            >
                              {head === "additionalcess" ? "Ad.Cess" : head}
                            </div>
                          ))}
                        </div>
                        {productTaxCalc.data?.map((data, i) => (
                          <div key={i} className="table-row">
                            <div
                              style={{
                                textAlign: "left",
                                fontWeight: "500",
                              }}
                              className="num-80"
                            >
                              {data.taxPercentage
                                ? parseFloat(data.taxPercentage).toFixed(1)
                                : 0.0}
                              %
                            </div>
                            <div
                              className="taxable"
                              style={{
                                textAlign: "left",
                                fontWeight: "500",
                              }}
                            >
                              {parseFloat(data.taxableValue).toFixed(2)}
                            </div>
                            {productTaxCalc?.head.map((head, i) => (
                              <div
                                style={{
                                  textAlign: "left",
                                  textTransform: "capitalize",
                                }}
                                className="num-80"
                              >
                                {data[head]
                                  ? parseFloat(data[head]).toFixed(2)
                                  : "-"}
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                </div>
                {invoiceSettings.ghoshaklogo && (
                  <div
                    className="Classic-footer-A4"
                    style={{
                      width: "auto",
                      marginLeft: "45px",
                      marginRight: "45px",
                      marginTop: "40px",
                      fontSize: "10PX",
                    }}
                  >
                    <div
                      style={{
                        width: "400",
                        backgroundColor: invoiceSettings.color,
                        display: "flex",
                        height: "40px",
                      }}
                    >
                      <div className="Classic-footer-A4-fooert-content">
                        Generate professional invoice using
                      </div>
                      <div className="Classic-footer-A4-fooert-content-1">
                        <img
                          src={Logo_Original}
                          style={{ height: "20px", width: "60px" }}
                        />
                      </div>
                      <div className="Classic-footer-A4-fooert-content-2">
                        Business app
                      </div>
                      <div className="Classic-footer-A4-fooert-content-3">
                        <img
                          src={Google}
                          style={{
                            height: "20px",
                            width: "60px",
                            marginLeft: "4px",
                            marginTop: "11px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } else if (A4design === "Simple") {
      return (
        <div>
          <div media="print">
            <div
              className="INVOICE-SIDEBAR-container4"
              style={{ display: "none" }}
            >
              {/* style={{display:"none"}}  */}
              <div className="INVOICE-SIDEBAR-menu-template">
                <div id="divToPrint" ref={ref}>
                  <div
                    className="Classic-A4-design"
                    style={{
                      fontSize: invoiceSettings.A4fontsize,
                      fontFamily: invoiceSettings.A4Fonttype,
                    }}
                  >
                    <div className="Modern-Header">
                      <div
                        className="Modern-Header-top"
                        style={{
                          display: "flex",
                          width: "100%",
                          backgroundColor: " #F3F3F3",
                        }}
                      >
                        <div
                          className="Modern-Header-top-left"
                          style={{ width: "60%", paddingLeft: "0px" }}
                        >
                          <div
                            className="Classic-Header-right-title"
                            style={{
                              color: invoiceSettings.color,
                              fontSize: "28px",
                              display: "flex",
                            }}
                          >
                            {invoiceSettings.shoplogo && (
                              <div style={{ padding: "5px" }}>
                                {shopDetails.shopIconLocation !== "removed" &&
                                  shopDetails.shopIconLocation !== "" && (
                                    <img
                                      src={shopDetails.shopIconLocation}
                                      alt="shoplogo"
                                      style={{
                                        width: "95px",
                                        height: "95px",
                                        paddingLeft: "2px",
                                        // borderRadius: "12px",
                                      }}
                                    />
                                  )}
                              </div>
                            )}
                            <div style={{ textAlign: "", fontSize: "35px" }}>
                              {shopDetails.shopName}
                            </div>
                          </div>

                          <div
                            className="Classic-body-bot-left-content"
                            style={{ marginTop: "50px" }}
                          >
                            <div>
                              Mobile:
                              {shopDetails.websiteContactPhoneNumber
                                ? shopDetails.websiteContactPhoneNumber
                                : shopDetails.shopPhoneNumber}
                            </div>
                            {shopDetails.shopGST && (
                              <div> {shopDetails.shopGST}</div>
                            )}
                            {invoiceSettings.ShopAddress && (
                              <div> {shopDetails.shopAddress}</div>
                            )}
                            <div>
                              {shopDetails.websiteUrl && (
                                <div>
                                  {invoiceSettings.ShopURL && (
                                    <div>
                                      {invoiceSettings.ShopURL && (
                                        <div>
                                          {shopDetails.customDomainUrl
                                            ? shopDetails.customDomainUrl
                                            : shopDetails.websiteUrl}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="Modern-Header-top-right"
                          style={{
                            width: "40%",
                            textAlign: "right",
                            paddingTop: "14px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "25px",
                              color: "#3F3F3F",
                              width: "0px",
                              marginLeft: "auto",
                              marginRight: "150px",
                            }}
                          >
                            Tax_Invoice
                          </div>
                          <div style={{ paddingTop: "5px" }}>
                            <div style={{}}>
                              <div>
                                <strong>Invoice No:</strong>
                                {invoiceSettings.invoiceprefix && (
                                  <span>{result.invoicePrefixField}</span>
                                )}
                                {result.invoiceNumber}
                              </div>

                              <div>
                                <strong>Invoice Date:</strong>
                                {currentDate}
                              </div>

                              <div style={{ overflowWrap: "break-word" }}>
                                <strong> Payment Method:</strong>
                                {paymentMethodGenerator(data.paymentMethod)}
                              </div>
                              {shopDetails.shopType === "Restaurant" && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {orderType[data.orderType]}
                                </div>
                              )}
                              {shopDetails.employeeName && (
                                <div
                                  style={{
                                    marginBottom: "2px",
                                    textAlign: "right",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <strong> Billed by: </strong>
                                  {shopDetails.employeeName}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="Modern-Header-bot"
                        style={{
                          display: "flex",
                          borderTop: "1px solid #000000",
                          marginBottom: "10px",
                        }}
                      >
                        <div
                          className="Simple-Header-bot-first"
                          style={{ width: "30%" }}
                        >
                          <div className="Elegant-address-rig">
                            <div>Invoice Details</div>
                            <div>
                              Invoice No:{" "}
                              {invoiceSettings.invoiceprefix && (
                                <span>{result.invoicePrefixField}</span>
                              )}
                              {result.invoiceNumber}
                            </div>
                            <div>
                              Invoice Date:
                              {currentDate}
                            </div>
                            {/* <li>Due Date:25-Aug-2021</li> */}
                          </div>
                        </div>
                        {invoiceSettings.customerprivacy &&
                          customerDetails.customerPhoneNumber &&
                          customerDetails.customerPhoneNumber != "NA" && (
                            <>
                              {(customerDetails.customerName &&
                                customerDetails.customerName != "NA") ||
                              (customerDetails.customerPhoneNumber &&
                                customerDetails.customerPhoneNumber != "NA") ||
                              (data.deliveryAddress &&
                                data.deliveryAddress !== "NA" &&
                                data.deliveryAddress !== "") ? (
                                <div
                                  className="Elegant-Header-bot-first"
                                  style={{ width: "35%", padding: "5px" }}
                                >
                                  <div className="Elegant-address-rig">
                                    {(customerDetails.customerName &&
                                      customerDetails.customerName != "NA") ||
                                    (customerDetails.customerPhoneNumber &&
                                      customerDetails.customerPhoneNumber !=
                                        "NA") ||
                                    (data.billingAddress &&
                                      data.billingAddress != "NA") ? (
                                      <div>
                                        {(invoiceSettings.customerprivacy ||
                                          invoiceSettings.deliveryaddress) && (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            Billed To
                                          </div>
                                        )}
                                      </div>
                                    ) : null}
                                    {invoiceSettings.customerprivacy && (
                                      <div>
                                        {customerDetails.customerName !== "" &&
                                          customerDetails.customerName !==
                                            "NA" && (
                                            <div>
                                              {customerDetails.customerName}
                                            </div>
                                          )}
                                      </div>
                                    )}
                                    {invoiceSettings.customerprivacy && (
                                      <div>
                                        {customerDetails.customerName !== "" &&
                                          customerDetails.customerName !==
                                            "NA" && (
                                            <div>
                                              {
                                                customerDetails.customerPhoneNumber
                                              }
                                            </div>
                                          )}
                                      </div>
                                    )}
                                    {invoiceSettings.deliveryaddress &&
                                      data.deliveryAddress !== "" &&
                                      data.deliveryAddress !== "NA" && (
                                        <div>
                                          {data.billingAddress !== "" &&
                                          data.billingAddress !== "NA" ? (
                                            <div>{data.billingAddress}</div>
                                          ) : null}
                                        </div>
                                      )}
                                  </div>
                                </div>
                              ) : null}
                            </>
                          )}
                        {invoiceSettings.deliveryaddress &&
                          data.deliveryAddress !== "" &&
                          data.deliveryAddress !== "NA" && (
                            <>
                              {(customerDetails.customerName &&
                                customerDetails.customerName != "NA") ||
                              (customerDetails.customerPhoneNumber &&
                                customerDetails.customerPhoneNumber != "NA") ||
                              (data.deliveryAddress &&
                                data.deliveryAddress != "NA" &&
                                data.deliveryAddress != "") ? (
                                <div style={{ width: "35%", padding: "5px" }}>
                                  {invoiceSettings.deliveryaddress &&
                                  data.deliveryAddress !== "NA" &&
                                  data.deliveryAddress !== "" ? (
                                    <div
                                      className="Elegant-Header-bot-first"
                                      style={{ width: "100%" }}
                                    >
                                      <div>
                                        {data.deliveryAddress &&
                                        data.deliveryAddress != "NA" &&
                                        data.deliveryAddress != "" ? (
                                          <div>
                                            {invoiceSettings.deliveryaddress && (
                                              <div
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                Shipping To
                                              </div>
                                            )}
                                          </div>
                                        ) : null}

                                        {invoiceSettings.deliveryaddress && (
                                          <div>
                                            {data.deliveryAddress !== "" &&
                                            data.deliveryAddress !== "NA" ? (
                                              <div
                                                style={{
                                                  overflowWrap: "break-word",
                                                }}
                                              >
                                                {data.deliveryAddress}
                                              </div>
                                            ) : null}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </>
                          )}
                      </div>
                    </div>
                    <hr style={{ margin: "0px", padding: "0px" }} />
                    <div
                      className="Classic-Body"
                      style={{ fontSize: invoiceSettings.A4fontsize }}
                    >
                      <div className="Elegant-Body-top">
                        <table style={{ width: "100%", height: "110px" }}>
                          <thead style={{ height: "30px" }}>
                            <tr
                              style={{
                                textAlign: "center",
                                height: "35px",
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                S.no
                              </th>

                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Items
                              </th>
                              {invoiceSettings.itemmrp ? (
                                <th
                                  style={{
                                    fontSize: invoiceSettings.A4fontsize,
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  MRP
                                </th>
                              ) : null}

                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Rate
                              </th>
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Qty
                              </th>
                              {invoiceSettings.itemdiscount ? (
                                <th
                                  style={{
                                    fontSize: invoiceSettings.A4fontsize,
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  Disc
                                </th>
                              ) : null}
                              {invoiceSettings.hsncode ? (
                                <th
                                  style={{
                                    fontSize: invoiceSettings.A4fontsize,
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  HSN
                                </th>
                              ) : null}
                              {invoiceSettings.itemleveltax ? (
                                <th
                                  style={{
                                    fontSize: invoiceSettings.A4fontsize,
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  Tax(%)
                                </th>
                              ) : null}
                              {shopDetails.shopType === "Mobile" &&
                                invoiceSettings.imei1imei2 && (
                                  <th
                                    style={{
                                      fontSize: invoiceSettings.A4fontsize,
                                      backgroundColor: invoiceSettings.color,
                                    }}
                                  >
                                    IMEI1/IMEI2
                                  </th>
                                )}
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {products.map((data, i) => (
                              <>
                                {parseFloat(data.itemTotal) !== 0 && (
                                  <tr key={i}>
                                    <td> {i + 1} </td>

                                    <td style={{ textAlign: "left" }}>
                                      {" "}
                                      {invoiceSettings.variant ? (
                                        <>
                                          {data.productName}-
                                          {data.unitOfMeasurment}
                                        </>
                                      ) : (
                                        <>{data.productName}</>
                                      )}
                                    </td>
                                    {invoiceSettings.itemmrp ? (
                                      <td>
                                        {data.productMrp
                                          ? data.productMrp
                                          : "-"}
                                      </td>
                                    ) : null}
                                    <td> {parseFloat(data.productPrice)}</td>
                                    <td>{parseFloat(data.count)}</td>

                                    {invoiceSettings.itemdiscount ? (
                                      <td>
                                        {data.discountPrice
                                          ? data.discountPrice
                                          : "-"}
                                        {data.discountType === "percentage"
                                          ? "%"
                                          : ""}
                                      </td>
                                    ) : null}
                                    {invoiceSettings.hsncode ? (
                                      <td>
                                        {data.productHsnCode
                                          ? data.productHsnCode
                                          : "-"}
                                      </td>
                                    ) : null}
                                    {invoiceSettings.itemleveltax ? (
                                      <td>
                                        {data.totalTax
                                          ? parseFloat(data.totalTax)
                                          : data.tax
                                          ? parseFloat(data.tax)
                                          : "-"}
                                      </td>
                                    ) : null}
                                    {shopDetails.shopType === "Mobile" &&
                                    invoiceSettings.imei1imei2 ? (
                                      <td>
                                        {data?.imei1
                                          ? data?.imei1
                                          : data?.imei2
                                          ? data?.imei2
                                          : "-"}
                                      </td>
                                    ) : null}

                                    <td>
                                      {data.itemTotal
                                        ? parseFloat(data.itemTotal).toFixed(2)
                                        : parseFloat(data.productPrice) *
                                          parseFloat(data.count)}
                                    </td>
                                  </tr>
                                )}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <hr style={{ border: "0.5px solid #000000" }} />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "2px 0",
                          marginLeft: "608px",
                          marginRight: "28px",
                          color: "black",
                        }}
                      >
                        <span>SUB Total</span>
                        <span>{currencyFormatter(result.billSubTotal)}</span>
                      </div>

                      {Boolean(
                        invoiceSettings.roundOff &&
                          Math.abs(result.roundOffAmount) > 0
                      ) && (
                        <>
                          <hr style={{ border: "0.5px solid #000000" }} />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "2px 0",
                              marginLeft: "608px",
                              marginRight: "28px",
                            }}
                          >
                            {/* <span>Items: {products.length}</span> */}
                            <span>Round Off</span>
                            <span>
                              {currencyFormatter(result.roundOffAmount)}
                            </span>
                          </div>
                        </>
                      )}
                      <hr style={{ border: "0.5px solid #000000" }} />
                      <div
                        className="Classic-Body-bot"
                        style={{ fontSize: invoiceSettings.A4fontsize }}
                      >
                        <div className="Classic-body-bot-left">
                          <div className="Classic-body-bot-left-content">
                            {!!(
                              invoiceSettings.notes && billInput.notes !== ""
                            ) &&
                              billInput.notes !== undefined && (
                                <div style={{ display: "flex" }}>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    <b>Notes: </b>
                                    <div
                                      style={{
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {billInput.notes}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>

                          {invoiceSettings.paymenyterms ? (
                            <div>
                              {invoiceSettings.paymentTermsField !== "" ? (
                                <div className="Classic-body-bot-left-content">
                                  <div style={{ fontWeight: 600 }}>
                                    Payment Terms:
                                  </div>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    {invoiceSettings.paymentTermsField}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          ) : null}

                          {/* {invoiceSettings.invoiceprefix ? (
                          <div>
                            {invoiceSettings.invoicePrefixtext !== "" ? (
                              <div className="Classic-body-bot-left-content">
                                <div>
                                  <strong>Invoice-Prefix: </strong>
                                   {result.invoicePrefixField}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null} */}
                          {invoiceSettings.termscondition ? (
                            <div>
                              {invoiceSettings.tAndCField !== "" ? (
                                <div className="Classic-body-bot-left-content">
                                  <div>
                                    <strong>Terms and Conditions:</strong>
                                  </div>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    {invoiceSettings.tAndCField}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                        <div className="Classic-body-bot-right">
                          <div className="Modern-body-bot-righ-top">
                            <div className="">
                              <div
                                style={{
                                  marginLeft: "70px",
                                  textAlign: "left",

                                  // width: "52%",
                                }}
                              >
                                {/* <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "2px 0",
                                }}
                              >
                              
                                <span>SUB</span>
                                <span>
                                  {currencyFormatter(result.billSubTotal)}
                                </span>
                              </div> */}
                                {Boolean(
                                  invoiceSettings.adddiscount &&
                                    billInput.billDiscount
                                ) && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "2px 0",
                                        color: "black",
                                      }}
                                    >
                                      <span> Discount(Flat)</span>
                                      <span
                                        style={{ overflowWrap: "break-word" }}
                                      >
                                        {discountType.billDiscountType ===
                                        "flat"
                                          ? billInput.billDiscount
                                            ? billInput.billDiscount
                                            : "0"
                                          : discountType.billDiscountType ===
                                            "percentage"
                                          ? parseFloat(
                                              (result.billSubTotal *
                                                billInput.billDiscount) /
                                                100
                                            ).toFixed(1)
                                          : 0}
                                      </span>
                                    </div>
                                  </>
                                )}
                                {Object.keys(couponObj).length > 0 && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "2px 0",
                                        color: "black",
                                      }}
                                    >
                                      <span>COUPON DISC</span>
                                      <span
                                        style={{ overflowWrap: "break-word" }}
                                      >
                                        {parseFloat(
                                          result.couponDiscountAmount
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                  </>
                                )}
                                {invoiceSettings.othercharges &&
                                  settings.otherChargesField?.length > 0 &&
                                  settings?.otherChargesField?.map((data) => {
                                    if (parseFloat(data.price)) {
                                      return (
                                        <div key={data.id}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              padding: "2px 0",
                                              color: "black",
                                            }}
                                            key={data.id}
                                          >
                                            <div>
                                              Other charges(
                                              {data.name
                                                .charAt(0)
                                                .toUpperCase() +
                                                data.name.slice(1)}
                                              )
                                            </div>
                                            <div>
                                              {data.price
                                                ? currencyFormatter(data.price)
                                                : ""}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}

                                {data.loyaltyDiscount > 0 && (
                                  <div>
                                    <div>
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "2px 0",
                                          color: "black",
                                        }}
                                      >
                                        <span
                                          style={{
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          Loyalty Discount
                                        </span>
                                        <span
                                          style={{
                                            overflowWrap: "break-word",
                                          }}
                                        >
                                          -
                                          {currencyFormatter(
                                            data.loyaltyDiscount
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* invoiceSettings.customerprivacy && */}
                                {customerDetails.customerPhoneNumber !== "" &&
                                  customerDetails.customerPhoneNumber !==
                                    "NA" &&
                                  invoiceSettings.customerprivacy && (
                                    <div>
                                      {invoiceSettings.customerprivacy && (
                                        <div>
                                          {Object.keys(loyaltyObj).length >
                                            0 && (
                                            <>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  padding: "2px 0",
                                                  color: "black",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    overflowWrap: "break-word",
                                                  }}
                                                >
                                                  {" "}
                                                  Loyalty Discount(Points)
                                                </span>
                                                <span
                                                  style={{
                                                    overflowWrap: "break-word",
                                                  }}
                                                >
                                                  {
                                                    loyaltyObj.minLoyaltyPointsReq
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                    fontWeight: 600,
                                    color: "black",
                                  }}
                                >
                                  <span>Total Amount</span>
                                  <span>
                                    {currencyFormatter(result.billFinalTotal)}
                                  </span>
                                </div>
                                <hr
                                  style={{
                                    // marginLeft: "56px",
                                    marginTop: "0px",
                                    marginBottom: "0px",
                                    border: ".5px solid",
                                  }}
                                />

                                {invoiceSettings.itemmrp && (
                                  <div>
                                    {calculateAmountSaved(products) > 0 && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "2px 0",
                                        }}
                                      >
                                        <div
                                          style={{
                                            fontWeight: "600",
                                            color: "black",
                                          }}
                                        >
                                          Saved Amount
                                        </div>
                                        <div
                                          style={{
                                            fontWeight: "600",
                                            fontSize: 18,
                                            color: "black",
                                          }}
                                        >
                                          {currencyFormatter(
                                            calculateAmountSaved(products)
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                    color: "black",
                                  }}
                                >
                                  <div>Amount Paid:</div>
                                  <div>
                                    {currencyFormatter(billInput.billPaid)}
                                  </div>
                                </div>
                                <hr
                                  style={{
                                    border: "1px solid rgb(63, 63, 63)",
                                  }}
                                />
                                {billInput.billAmountDue < 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                      color: "black",
                                    }}
                                  >
                                    <div>Balance Amount:</div>
                                    <div>
                                      {currencyFormatter(
                                        Math.abs(billInput.billAmountDue)
                                      )}
                                    </div>
                                  </div>
                                )}
                                {billInput.billAmountDue > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                      color: "black",
                                    }}
                                  >
                                    <div>Amount Due:</div>
                                    <div>
                                      <strong>
                                        {currencyFormatter(
                                          Math.abs(billInput.billAmountDue)
                                        )}
                                      </strong>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="Classic-body-bot-righ-bot">
                            <div
                              style={{
                                display: "flex",
                                gap: "5px",
                                color: "black",
                              }}
                            >
                              <div style={{ color: "black" }}>
                                <strong>Total in Words:</strong>
                              </div>
                              <div style={{ overflowWrap: "break-word" }}>
                                {inWords(result.billFinalTotal)}Only
                              </div>
                            </div>

                            {shopDetails.loyaltyPackage === "yes" &&
                              customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" &&
                              invoiceSettings.customerprivacy && (
                                <div style={{ display: "flex" }}>
                                  <div>Available Loyalty Pts:</div>
                                  <div>
                                    {loyaltyObj.minLoyaltyPointsReq
                                      ? (
                                          parseFloat(
                                            getUpdatedLoyaltyPoints(
                                              result.billFinalTotal,
                                              loyaltyPoints ? loyaltyPoints : 0
                                            )
                                          ) -
                                          parseFloat(
                                            loyaltyObj.minLoyaltyPointsReq
                                          )
                                        ).toFixed(2)
                                      : getUpdatedLoyaltyPoints(
                                          result.billFinalTotal,
                                          loyaltyPoints ? loyaltyPoints : 0
                                        ).toFixed(2)}
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {invoiceSettings.itemleveltax &&
                        productTaxCalc?.data?.length > 0 && (
                          <div style={{}}>
                            <div
                              class="table-row header"
                              style={{ border: "none" }}
                            >
                              <div
                                style={{
                                  textAlign: "left",
                                }}
                                className="num-80"
                              >
                                Desc
                              </div>
                              <div
                                style={{
                                  textAlign: "left",
                                }}
                                className="taxable"
                              >
                                Taxable
                              </div>
                              {productTaxCalc?.head.map((head, i) => (
                                <div
                                  style={{
                                    textAlign: "left",
                                    textTransform: "capitalize",
                                  }}
                                  className="num-80"
                                >
                                  {head === "additionalcess" ? "Ad.Cess" : head}
                                </div>
                              ))}
                            </div>
                            {productTaxCalc?.data?.map((data, i) => (
                              <div
                                key={i}
                                className="table-row"
                                style={{ border: "none" }}
                              >
                                {/* <div
                                className="dash"
                                style={{
                                  margin: "4px 0",
                                }}
                              /> */}
                                <div
                                  style={{
                                    textAlign: "left",
                                  }}
                                  className="num-80"
                                >
                                  {data.taxPercentage
                                    ? parseFloat(data.taxPercentage).toFixed(1)
                                    : 0.0}
                                  %
                                </div>
                                <div
                                  className="taxable"
                                  style={{ textAlign: "left" }}
                                >
                                  {parseFloat(data.taxableValue).toFixed(2)}
                                </div>
                                {productTaxCalc?.head.map((head, i) => (
                                  <div
                                    style={{
                                      textAlign: "left",
                                      textTransform: "capitalize",
                                    }}
                                    className="num-80"
                                  >
                                    {data[head]
                                      ? parseFloat(data[head]).toFixed(2)
                                      : "-"}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                    {invoiceSettings.ghoshaklogo && (
                      <div
                        className="Classic-footer-A4"
                        style={{
                          width: "auto",
                          marginLeft: "45px",
                          marginRight: "45px",
                          fontSize: "10PX",
                        }}
                      >
                        <div
                          style={{
                            width: "400",
                            backgroundColor: invoiceSettings.color,
                            display: "flex",
                            height: "40px",
                          }}
                        >
                          <div className="Classic-footer-A4-fooert-content">
                            Generate professional invoice using
                          </div>
                          <div className="Classic-footer-A4-fooert-content-1">
                            <img
                              src={Logo_Original}
                              style={{ height: "20px", width: "auto" }}
                            />
                          </div>
                          <div className="Classic-footer-A4-fooert-content-2">
                            Business app
                          </div>
                          <div className="Classic-footer-A4-fooert-content-3">
                            <img
                              src={Google}
                              style={{
                                height: "20px",
                                width: "auto",
                                marginLeft: "4px",
                                marginTop: "11px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (A4design === "Modern") {
      return (
        <div>
          <div
            className="INVOICE-SIDEBAR-container4"
            style={{ display: "none" }}
          >
            {/* style={{display:"none"}}  */}
            <div className="INVOICE-SIDEBAR-menu-template">
              <div id="divToPrint" ref={ref}>
                <div
                  className="Classic-A4-design"
                  style={{
                    fontSize: invoiceSettings.A4fontsize,
                    fontFamily: invoiceSettings.A4Fonttype,
                  }}
                >
                  <div
                    className="Modern-Header"
                    style={{ fontSize: invoiceSettings.A4fontsize }}
                  >
                    <div
                      className="Modern-Header-top"
                      style={{ display: "flex", width: "100%" }}
                    >
                      <div
                        className="Modern-Header-top-left"
                        style={{ width: "50%" }}
                      >
                        {invoiceSettings.shoplogo && (
                          <div style={{ padding: "5px" }}>
                            {shopDetails.shopIconLocation !== "removed" &&
                              shopDetails.shopIconLocation !== "" && (
                                <img
                                  src={shopDetails.shopIconLocation}
                                  alt="shoplogo"
                                  style={{
                                    width: "95px",
                                    height: "95px",
                                    paddingLeft: "2px",
                                    // borderRadius: "12px",
                                  }}
                                />
                              )}
                          </div>
                        )}
                        <div
                          className="Classic-Header-right-title"
                          style={{
                            textAlign: "left",
                            color: invoiceSettings.color,
                            fontSize: "35px",
                          }}
                        >
                          {shopDetails.shopName}
                        </div>
                      </div>
                      <div
                        className="Modern-Header-top-right"
                        style={{ width: "50%", textAlign: "right" }}
                      >
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "30px",
                            lineHeight: "36px",
                            color: "#3F3F3F",
                            backgroundColor: "#F3F3F3",
                            borderRadius: "0px 0px 0px 35px",
                            width: "auto",
                            marginLeft: "75px",
                          }}
                        >
                          Invoice
                        </div>
                        <div style={{ paddingTop: "5px" }}>
                          <div style={{ color: "black" }}>
                            Mobile:
                            {shopDetails.websiteContactPhoneNumber
                              ? shopDetails.websiteContactPhoneNumber
                              : shopDetails.shopPhoneNumber}
                          </div>
                          {shopDetails.websiteUrl && (
                            <div style={{ color: "black" }}>
                              {invoiceSettings.ShopURL && (
                                <div>
                                  {shopDetails.customDomainUrl
                                    ? shopDetails.customDomainUrl
                                    : shopDetails.websiteUrl}
                                </div>
                              )}
                            </div>
                          )}
                          {invoiceSettings.ShopAddress && (
                            <div style={{ color: "black" }}>
                              {shopDetails.shopAddress}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      className="Modern-Header-bot"
                      style={{ display: "flex", marginBottom: "10px" }}
                    >
                      <div
                        className="Modern-Header-bot-first"
                        style={{ width: "34%" }}
                      >
                        <div className="Modern-Header-bot-first">
                          <div>Invoice Details</div>
                          <div>
                            Invoice No:{" "}
                            {invoiceSettings.invoiceprefix && (
                              <span>{result.invoicePrefixField}</span>
                            )}
                            {result.invoiceNumber}
                          </div>
                          <div>
                            Invoice Date:
                            {currentDate}
                          </div>

                          <div>
                            <div style={{ overflowWrap: "break-word" }}>
                              <strong>Payment Mode:</strong>
                              {paymentMethodGenerator(data.paymentMethod)}
                            </div>
                          </div>
                          {shopDetails.shopType === "Restaurant" && (
                            <div
                              style={{
                                textAlign: "center",
                                fontWeight: "600",
                                textTransform: "uppercase",
                                color: "black",
                              }}
                            >
                              {orderType[data.orderType]}
                            </div>
                          )}
                          {shopDetails.employeeName && (
                            <div
                              style={{
                                marginBottom: "2px",
                                textAlign: "left",
                                overflowWrap: "break-word",
                                color: "black",
                              }}
                            >
                              <strong>Billed by: </strong>
                              {shopDetails.employeeName}
                            </div>
                          )}
                        </div>
                      </div>

                      {invoiceSettings.customerprivacy && (
                        <>
                          {customerDetails.customerName ||
                          customerDetails.customerPhoneNumber ||
                          data.deliveryAddress !== "" ? (
                            <div
                              className="Modern-Header-bot-first"
                              style={{ width: "33%" }}
                            >
                              <div
                                style={{
                                  borderLeft: "3px solid #F3F3F3",
                                  paddingLeft: "15px",
                                }}
                              >
                                {(customerDetails.customerName &&
                                  customerDetails.customerName != "NA") ||
                                (customerDetails.customerPhoneNumber &&
                                  customerDetails.customerPhoneNumber !=
                                    "NA") ||
                                (data.billingAddress &&
                                  data.billingAddress != "NA") ? (
                                  <div>
                                    {(invoiceSettings.customerprivacy ||
                                      invoiceSettings.deliveryaddress) && (
                                      <div style={{ whiteSpace: "nowrap" }}>
                                        Invoice To.
                                      </div>
                                    )}
                                  </div>
                                ) : null}
                                {invoiceSettings.customerprivacy && (
                                  <div>
                                    {customerDetails.customerName !== "" &&
                                      customerDetails.customerName !== "NA" && (
                                        <div>
                                          {customerDetails.customerName}
                                        </div>
                                      )}
                                  </div>
                                )}
                                {invoiceSettings.customerprivacy && (
                                  <div>
                                    {customerDetails.customerName !== "" &&
                                      customerDetails.customerName !== "NA" && (
                                        <div>
                                          {customerDetails.customerPhoneNumber}
                                        </div>
                                      )}
                                  </div>
                                )}
                                {invoiceSettings.deliveryaddress && (
                                  <div>
                                    {data.billingAddress !== "" &&
                                    data.billingAddress !== "NA" ? (
                                      <div>{data.billingAddress}</div>
                                    ) : null}
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </>
                      )}

                      {invoiceSettings.deliveryaddress &&
                        data.deliveryAddress !== "" &&
                        data.deliveryAddress !== "NA" && (
                          <>
                            {data.deliveryAddress &&
                            data.deliveryAddress != "NA" &&
                            data.deliveryAddress != "" ? (
                              <div>
                                {invoiceSettings.deliveryaddress ? (
                                  <div
                                    className="Modern-Header-bot-sec"
                                    style={{ width: "33%" }}
                                  >
                                    <div className="Modern-Header-bot-thi">
                                      {(invoiceSettings.customerprivacy ||
                                        invoiceSettings.deliveryaddress) && (
                                        <div>Shipping To</div>
                                      )}

                                      {invoiceSettings.deliveryaddress && (
                                        <div>
                                          {data.deliveryAddress !== "" &&
                                          data.deliveryAddress !== "NA" ? (
                                            <div>{data.deliveryAddress}</div>
                                          ) : null}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            ) : null}
                          </>
                        )}
                    </div>
                  </div>
                  <hr style={{ margin: "0px", padding: "0px" }} />
                  <div
                    className="Classic-Body"
                    style={{ fontSize: invoiceSettings.A4fontsize }}
                  >
                    <div className="Modern-Body-top">
                      <table style={{ width: "100%", height: "80px" }}>
                        <thead style={{ height: "30px" }}>
                          <tr style={{ textAlign: "center" }}>
                            <th
                              style={{
                                fontSize: invoiceSettings.A4fontsize,
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              S.no
                            </th>

                            <th
                              style={{
                                fontSize: invoiceSettings.A4fontsize,
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              Items
                            </th>
                            {invoiceSettings.itemmrp ? (
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                MRP
                              </th>
                            ) : null}

                            <th
                              style={{
                                fontSize: invoiceSettings.A4fontsize,
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              Rate
                            </th>
                            <th
                              style={{
                                fontSize: invoiceSettings.A4fontsize,
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              Qty
                            </th>
                            {invoiceSettings.itemdiscount ? (
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Disc
                              </th>
                            ) : null}
                            {invoiceSettings.hsncode ? (
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                HSN
                              </th>
                            ) : null}
                            {invoiceSettings.itemleveltax ? (
                              <th
                                style={{
                                  fontSize: invoiceSettings.A4fontsize,
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Tax(%)
                              </th>
                            ) : null}
                            {shopDetails.shopType === "Mobile" &&
                              invoiceSettings.imei1imei2 && (
                                <th
                                  style={{
                                    fontSize: invoiceSettings.A4fontsize,
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  IMEI1/IMEI2
                                </th>
                              )}

                            <th
                              style={{
                                fontSize: invoiceSettings.A4fontsize,
                                backgroundColor: invoiceSettings.color,
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {products.map((data, i) => (
                            <>
                              {parseFloat(data.itemTotal) !== 0 && (
                                <tr key={i}>
                                  <td>{i + 1}</td>

                                  <td
                                    style={{
                                      textAlign: "left",
                                      paddingLeft: "4px",
                                    }}
                                  >
                                    {" "}
                                    {invoiceSettings.variant ? (
                                      <>
                                        {data.productName}-
                                        {data.unitOfMeasurment}
                                      </>
                                    ) : (
                                      <>{data.productName}</>
                                    )}
                                  </td>
                                  {invoiceSettings.itemmrp ? (
                                    <td>
                                      {data.productMrp ? data.productMrp : "-"}
                                    </td>
                                  ) : null}
                                  <td> {parseFloat(data.productPrice)}</td>
                                  <td>{parseFloat(data.count)}</td>

                                  {invoiceSettings.itemdiscount ? (
                                    <td>
                                      {data.discountPrice
                                        ? data.discountPrice
                                        : "-"}
                                      {data.discountType === "percentage"
                                        ? "%"
                                        : ""}
                                    </td>
                                  ) : null}
                                  {invoiceSettings.hsncode ? (
                                    <td>
                                      {data.productHsnCode
                                        ? data.productHsnCode
                                        : "-"}
                                    </td>
                                  ) : null}
                                  {invoiceSettings.itemleveltax ? (
                                    <td>
                                      {data.totalTax
                                        ? parseFloat(data.totalTax)
                                        : data.tax
                                        ? parseFloat(data.tax)
                                        : "-"}
                                    </td>
                                  ) : null}
                                  {shopDetails.shopType === "Mobile" &&
                                  invoiceSettings.imei1imei2 ? (
                                    <td>
                                      {data?.imei1
                                        ? data?.imei1
                                        : data?.imei2
                                        ? data?.imei2
                                        : "-"}
                                    </td>
                                  ) : null}

                                  <td>
                                    {data.itemTotal
                                      ? parseFloat(data.itemTotal).toFixed(2)
                                      : parseFloat(data.productPrice) *
                                        parseFloat(data.count)}
                                  </td>
                                </tr>
                              )}
                            </>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div
                      className="Classic-Body-bot"
                      style={{ fontSize: invoiceSettings.A4fontsize }}
                    >
                      <div className="Classic-body-bot-left">
                        <div className="Classic-body-bot-left-content">
                          {!!(
                            invoiceSettings.notes && billInput.notes !== ""
                          ) &&
                            billInput.notes !== undefined && (
                              <div style={{ display: "flex" }}>
                                <div style={{ overflowWrap: "break-word" }}>
                                  <b>Notes: </b>
                                  <div
                                    style={{
                                      overflowWrap: "break-word",
                                    }}
                                  >
                                    {billInput.notes}
                                  </div>
                                </div>
                              </div>
                            )}
                        </div>
                        {invoiceSettings.termscondition ? (
                          <div>
                            {invoiceSettings.tAndCField !== "" ? (
                              <div className="Classic-body-bot-left-content">
                                <div>
                                  <strong>Terms and Conditions:</strong>
                                </div>
                                <div style={{ overflowWrap: "break-word" }}>
                                  {invoiceSettings.tAndCField}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                        {invoiceSettings.paymenyterms ? (
                          <div>
                            {invoiceSettings.paymentTermsField !== "" ? (
                              <div className="Classic-body-bot-left-content">
                                <div style={{ fontWeight: 600 }}>
                                  Payment Terms:
                                </div>
                                <div style={{ overflowWrap: "break-word" }}>
                                  {invoiceSettings.paymentTermsField}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                        {/* {invoiceSettings.duedate?<div className='Classic-body-bot-left-content'>
<div>Due Date:25-Aug-2021</div>

</div>:null} */}
                        {/* {invoiceSettings.invoiceprefix ? (
                        <div>
                          {invoiceSettings.invoicePrefixtext !== "" ? (
                            <div className="Classic-body-bot-left-content">
                              <div>
                                <strong>Invoice-Prefix: </strong>
                                 {result.invoicePrefixField}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ) : null} */}
                      </div>
                      <div className="Classic-body-bot-right">
                        <div className="Classic-body-bot-righ-top">
                          <div style={{ marginLeft: "70px" }}>
                            <table className="Invoice-table">
                              <tr className="Invoice-table-tr">
                                <th className="Invoice-table-th">SUB Total</th>
                                <th
                                  className="Invoice-table-th-right"
                                  style={{ overflowWrap: "break-word" }}
                                >
                                  {currencyFormatter(result.billSubTotal)}
                                </th>
                              </tr>
                              {data.loyaltyDiscount > 0 && (
                                <tr className="Invoice-table-tr">
                                  <th className="Invoice-table-th">
                                    Loyalty Discount
                                  </th>
                                  <th
                                    className="Invoice-table-th-right"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    -{currencyFormatter(data.loyaltyDiscount)}
                                  </th>
                                </tr>
                              )}
                              {Boolean(
                                invoiceSettings.roundOff &&
                                  Math.abs(result.roundOffAmount) > 0
                              ) && (
                                <tr className="Invoice-table-tr">
                                  <th className="Invoice-table-th">
                                    Round Off
                                  </th>
                                  <th
                                    className="Invoice-table-th-right"
                                    style={{ overflowWrap: "break-word" }}
                                  >
                                    {currencyFormatter(result.roundOffAmount)}
                                  </th>
                                </tr>
                              )}
                              {Boolean(
                                invoiceSettings.adddiscount &&
                                  billInput.billDiscount
                              ) && (
                                <tr className="Invoice-table-tr">
                                  <th className="Invoice-table-th">
                                    {" "}
                                    Discount(Flat)
                                  </th>
                                  <th className="Invoice-table-th-right">
                                    {country.CurrencySymbol}
                                    {discountType.billDiscountType === "flat"
                                      ? billInput.billDiscount
                                        ? billInput.billDiscount
                                        : "0"
                                      : discountType.billDiscountType ===
                                        "percentage"
                                      ? parseFloat(
                                          (result.billSubTotal *
                                            billInput.billDiscount) /
                                            100
                                        ).toFixed(1)
                                      : 0}
                                  </th>
                                </tr>
                              )}

                              {Object.keys(couponObj).length > 0 && (
                                <tr className="Invoice-table-tr">
                                  <th className="Invoice-table-th">
                                    COUPON DISC
                                  </th>
                                  <th className="Invoice-table-th-right">
                                    {parseFloat(
                                      result.couponDiscountAmount
                                    ).toFixed(2)}
                                  </th>
                                </tr>
                              )}

                              {invoiceSettings.othercharges &&
                                settings.otherChargesField?.length > 0 &&
                                settings?.otherChargesField?.map((data) => {
                                  if (parseFloat(data.price)) {
                                    return (
                                      <tr
                                        key={data.id}
                                        className="Invoice-table-tr"
                                      >
                                        <th className="Invoice-table-th">
                                          Other charges(
                                          {data.name.charAt(0).toUpperCase() +
                                            data.name.slice(1)}
                                          )
                                        </th>
                                        <th className="Invoice-table-th-right">
                                          {data.price
                                            ? currencyFormatter(data.price)
                                            : ""}
                                        </th>
                                      </tr>
                                    );
                                  }
                                })}

                              {invoiceSettings.customerprivacy &&
                                Object.keys(loyaltyObj).length > 0 &&
                                customerDetails.customerPhoneNumber !== "" &&
                                customerDetails.customerPhoneNumber !==
                                  "NA" && (
                                  <tr className="Invoice-table-tr">
                                    <th className="Invoice-table-th">
                                      Loyalty Discount(Points)
                                    </th>
                                    <th className="Invoice-table-th-right">
                                      {loyaltyObj.minLoyaltyPointsReq}
                                    </th>
                                  </tr>
                                )}

                              <tr className="Invoice-table-tr">
                                <th
                                  className="Invoice-table-th"
                                  style={{ fontWeight: "600" }}
                                >
                                  Total Amount
                                </th>
                                <th
                                  className="Invoice-table-th-right"
                                  style={{ fontWeight: "600" }}
                                >
                                  {currencyFormatter(result.billFinalTotal)}
                                </th>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div
                          className="Classic-body-bot-righ-mid"
                          style={{ display: "flex" }}
                        >
                          <div
                            className="Classic-body-bot-righ-mid-first"
                            style={{}}
                          >
                            {invoiceSettings.itemmrp && (
                              <div>
                                {calculateAmountSaved(products) > 0 && (
                                  <div style={{ fontWeight: "600" }}>
                                    Saved Amount
                                  </div>
                                )}
                              </div>
                            )}
                            <div>Amount Paid:</div>
                            {billInput.billAmountDue < 0 && (
                              <div>Balance Amount:</div>
                            )}
                            {billInput.billAmountDue > 0 && (
                              <div>Amount Due:</div>
                            )}
                          </div>
                          <div
                            className="Classic-body-bot-righ-mid-second"
                            style={{}}
                          >
                            {invoiceSettings.itemmrp && (
                              <div>
                                {calculateAmountSaved(products) > 0 && (
                                  <div style={{ fontWeight: "600" }}>
                                    {currencyFormatter(
                                      calculateAmountSaved(products)
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            <div>{currencyFormatter(billInput.billPaid)}</div>
                            {billInput.billAmountDue < 0 && (
                              <div>
                                {currencyFormatter(
                                  Math.abs(billInput.billAmountDue)
                                )}
                              </div>
                            )}
                            {billInput.billAmountDue > 0 && (
                              <div>
                                <strong>
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </strong>
                              </div>
                            )}
                          </div>
                        </div>
                        <hr
                          style={{
                            marginLeft: "76px",
                            marginTop: "0px",
                            marginBottom: "0px",
                            bordertop: "2px solid",
                          }}
                        />
                        <div className="Classic-body-bot-righ-bot">
                          {shopDetails.loyaltyPackage === "yes" &&
                            customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA" &&
                            invoiceSettings.customerprivacy && (
                              <div
                                style={{
                                  display: "flex",
                                  gap: "2px",
                                  overflowWrap: "break-word",
                                }}
                              >
                                <strong>Available Loyalty Pts:</strong>
                                <div>
                                  {loyaltyObj.minLoyaltyPointsReq
                                    ? (
                                        parseFloat(
                                          getUpdatedLoyaltyPoints(
                                            result.billFinalTotal,
                                            loyaltyPoints ? loyaltyPoints : 0
                                          )
                                        ) -
                                        parseFloat(
                                          loyaltyObj.minLoyaltyPointsReq
                                        )
                                      ).toFixed(2)
                                    : getUpdatedLoyaltyPoints(
                                        result.billFinalTotal,
                                        loyaltyPoints ? loyaltyPoints : 0
                                      ).toFixed(2)}
                                </div>
                              </div>
                            )}
                          <div style={{ display: "flex" }}>
                            <div>
                              <strong>Total in Words:</strong>
                            </div>
                            <div> {inWords(result.billFinalTotal)}Only</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={{ width: "50%", marginBottom: "10px" }}>
                    {invoiceSettings.itemleveltax &&
                      productTaxCalc?.data?.length > 0 && (
                        <div
                          style={{
                            fontSize: invoiceSettings.A4fontsize,
                          }}
                        >
                          <div
                            class="table-row header"
                            style={{ border: "none" }}
                          >
                            <div
                              style={{
                                textAlign: "left",
                              }}
                              className="num-80"
                            >
                              Desc
                            </div>
                            <div
                              style={{
                                textAlign: "left",
                              }}
                              className="taxable"
                            >
                              Taxable
                            </div>
                            {productTaxCalc?.head.map((head, i) => (
                              <div
                                style={{
                                  textAlign: "left",
                                  textTransform: "capitalize",
                                }}
                                className="num-80"
                              >
                                {head === "additionalcess" ? "Ad.Cess" : head}
                              </div>
                            ))}
                          </div>
                          {productTaxCalc?.data?.map((data, i) => (
                            <div
                              key={i}
                              className="table-row"
                              style={{ border: "none" }}
                            >
                              {/* <div
                            className="dash"
                            style={{
                              margin: "4px 0",
                            }}
                          /> */}
                              <div
                                style={{
                                  textAlign: "left",
                                }}
                                className="num-80"
                              >
                                {data.taxPercentage
                                  ? parseFloat(data.taxPercentage).toFixed(1)
                                  : 0.0}
                                %
                              </div>
                              <div
                                className="taxable"
                                style={{ textAlign: "left" }}
                              >
                                {parseFloat(data.taxableValue).toFixed(2)}
                              </div>
                              {productTaxCalc?.head.map((head, i) => (
                                <div
                                  style={{
                                    textAlign: "left",
                                    textTransform: "capitalize",
                                  }}
                                  className="num-80"
                                >
                                  {data[head]
                                    ? parseFloat(data[head]).toFixed(2)
                                    : "-"}
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      )}
                  </div>
                  {invoiceSettings.ghoshaklogo && (
                    <div
                      className="Classic-footer-A4"
                      style={{
                        width: "auto",
                        marginLeft: "45px",
                        marginRight: "45px",
                        fontSize: "14PX",
                      }}
                    >
                      <div
                        style={{
                          width: "400",
                          backgroundColor: invoiceSettings.color,
                          display: "flex",
                          height: "40px",
                        }}
                      >
                        <div className="Classic-footer-A4-fooert-content">
                          Generate professional invoice using
                        </div>
                        <div className="Classic-footer-A4-fooert-content-1">
                          <img
                            src={Logo_Original}
                            style={{ height: "20px", width: "60px" }}
                            alt="logo"
                          />
                        </div>
                        <div className="Classic-footer-A4-fooert-content-2">
                          Business app
                        </div>
                        <div className="Classic-footer-A4-fooert-content-3">
                          <img
                            src={Google}
                            style={{
                              height: "20px",
                              width: "60px",
                              marginLeft: "4px",
                              marginTop: "11px",
                            }}
                            alt="googlelogo"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (A4design === "Elegant") {
      return (
        <div>
          <div>
            <div
              className="INVOICE-SIDEBAR-container4"
              style={{ display: "none" }}
            >
              {/* style={{display:"none"}} */}
              <div className="INVOICE-SIDEBAR-menu-template">
                <div id="divToPrint" ref={ref}>
                  <div
                    className="Classic-A4-design"
                    style={{
                      fontSize: invoiceSettings.A4fontsize,
                      fontFamily: invoiceSettings.A4Fonttype,
                    }}
                  >
                    <div className="Modern-Header">
                      <div
                        className="Modern-Header-top"
                        style={{ display: "flex", width: "100%" }}
                      >
                        <div
                          className="Modern-Header-top-left"
                          style={{ width: "60%", paddingLeft: "0px" }}
                        >
                          <div
                            className="Classic-Header-right-title"
                            style={{
                              color: invoiceSettings.color,
                              fontSize: "28px",
                              display: "flex",
                            }}
                          >
                            {invoiceSettings.shoplogo && (
                              <div style={{ padding: "5px" }}>
                                {shopDetails.shopIconLocation !== "removed" &&
                                  shopDetails.shopIconLocation !== "" && (
                                    <img
                                      src={shopDetails.shopIconLocation}
                                      alt="shoplogo"
                                      style={{
                                        width: "95px",
                                        height: "95px",
                                        paddingLeft: "2px",

                                        // borderRadius: "12px",
                                      }}
                                    />
                                  )}
                              </div>
                            )}
                            <div
                              style={{ textAlign: "left", fontSize: "35px" }}
                            >
                              {shopDetails.shopName}
                            </div>
                          </div>

                          <div
                            className="Classic-body-bot-left-content"
                            style={{ textAlign: "left", marginTop: "50px" }}
                          >
                            <div>
                              Mobile:
                              {shopDetails.websiteContactPhoneNumber
                                ? shopDetails.websiteContactPhoneNumber
                                : shopDetails.shopPhoneNumber}
                            </div>
                            {shopDetails.shopGST && (
                              <div> {shopDetails.shopGST}</div>
                            )}
                            {invoiceSettings.ShopAddress && (
                              <div style={color}>{shopDetails.shopAddress}</div>
                            )}
                            <div>
                              {shopDetails.websiteUrl && (
                                <div>
                                  {invoiceSettings.ShopURL && (
                                    <div>
                                      {shopDetails.customDomainUrl
                                        ? shopDetails.customDomainUrl
                                        : shopDetails.websiteUrl}
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className="Modern-Header-top-right"
                          style={{
                            width: "40%",
                            textAlign: "right",
                            paddingTop: "14px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "25px",
                              color: "#3F3F3F",
                              width: "0px",
                              marginLeft: "330px",
                            }}
                          >
                            Invoice
                          </div>
                          <div style={{ paddingTop: "5px" }}>
                            <div style={{ color: "black" }}>
                              <div style={{ color: "black" }}>
                                <strong>Invoice No:</strong>
                                {invoiceSettings.invoiceprefix && (
                                  <span>{result.invoicePrefixField}</span>
                                )}

                                {result.invoiceNumber}
                              </div>
                              <div></div>
                              <div>
                                <strong>Invoice Date: </strong>
                                {currentDate}
                              </div>

                              <div
                                style={{
                                  fontWeight: "600",
                                  overflowWrap: "break-word",
                                }}
                              >
                                Payment Method:
                                {paymentMethodGenerator(data.paymentMethod)}
                              </div>
                              {shopDetails.shopType === "Restaurant" && (
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "600",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {orderType[data.orderType]}
                                </div>
                              )}
                              {shopDetails.employeeName && (
                                <div
                                  style={{
                                    textAlign: "right",
                                    marginBottom: "2px",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  Billed by: {shopDetails.employeeName}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="Modern-Header-bot"
                        style={{
                          display: "flex",
                          borderTop: "1px solid #000000",
                          marginBottom: "10px",
                        }}
                      >
                        {invoiceSettings.customerprivacy &&
                          customerDetails.customerPhoneNumber !== "" &&
                          customerDetails.customerPhoneNumber !== "NA" && (
                            <>
                              {(customerDetails.customerName !== "" &&
                                customerDetails.customerName != "NA") ||
                              (customerDetails.customerPhoneNumber !== "" &&
                                customerDetails.customerPhoneNumber != "NA") ||
                              (data.billingAddress !== "" &&
                                data.billingAddress != "NA") ? (
                                <div className="Elegant-Header-bot-first">
                                  <div className="Elegant-address-rig">
                                    {(customerDetails.customerName !== "" &&
                                      customerDetails.customerName != "NA") ||
                                    (customerDetails.customerPhoneNumber !==
                                      "" &&
                                      customerDetails.customerPhoneNumber !=
                                        "NA") ||
                                    (data.billingAddress !== "" &&
                                      data.billingAddress != "NA") ? (
                                      <div>
                                        {(invoiceSettings.customerprivacy ||
                                          invoiceSettings.deliveryaddress) && (
                                          <div style={{ whiteSpace: "nowrap" }}>
                                            Billed To
                                          </div>
                                        )}
                                      </div>
                                    ) : null}
                                    {invoiceSettings.customerprivacy && (
                                      <div>
                                        {customerDetails.customerName !== "" &&
                                          customerDetails.customerName !==
                                            "NA" && (
                                            <div
                                              style={{ whiteSpace: "nowrap" }}
                                            >
                                              {customerDetails.customerName}
                                            </div>
                                          )}
                                      </div>
                                    )}
                                    {invoiceSettings.customerprivacy && (
                                      <div>
                                        {customerDetails.customerName !== "" &&
                                          customerDetails.customerName !==
                                            "NA" && (
                                            <div>
                                              {
                                                customerDetails.customerPhoneNumber
                                              }
                                            </div>
                                          )}
                                      </div>
                                    )}
                                    {invoiceSettings.deliveryaddress && (
                                      <div>
                                        {data.billingAddress !== "" &&
                                        data.billingAddress !== "NA" ? (
                                          <div>{data.billingAddress}</div>
                                        ) : null}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : null}
                            </>
                          )}
                        {invoiceSettings.deliveryaddress &&
                          data.deliveryAddress !== "" &&
                          data.deliveryAddress !== "NA" && (
                            <>
                              {data.deliveryAddress &&
                              data.deliveryAddress !== "NA" &&
                              data.deliveryAddress !== "" ? (
                                <div>
                                  {invoiceSettings.deliveryaddress &&
                                  data.deliveryAddress != "" &&
                                  data.deliveryAddress !== "NA" ? (
                                    <div className="Elegant-Header-bot-first">
                                      <div className="Elegant-address">
                                        {data.deliveryAddress &&
                                        data.deliveryAddress != "NA" &&
                                        data.deliveryAddress != "" ? (
                                          <div>
                                            {(invoiceSettings.customerprivacy ||
                                              invoiceSettings.deliveryaddress) && (
                                              <div
                                                style={{ whiteSpace: "nowrap" }}
                                              >
                                                Shipping To
                                              </div>
                                            )}
                                          </div>
                                        ) : null}

                                        {invoiceSettings.deliveryaddress && (
                                          <div>
                                            {data.deliveryAddress !== "" &&
                                            data.deliveryAddress !== "NA" ? (
                                              <div>{data.deliveryAddress}</div>
                                            ) : null}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ) : null}
                                </div>
                              ) : null}
                            </>
                          )}
                      </div>
                    </div>
                    <hr style={{ margin: "0px", padding: "0px" }} />
                    <div
                      className="Classic-Body"
                      style={{ fontSize: invoiceSettings.A4fontsize }}
                    >
                      <div className="Elegant-Body-top">
                        <table style={{ width: "100%", height: "110px" }}>
                          <thead style={{ height: "30px" }}>
                            <tr style={{ textAlign: "center", height: "35px" }}>
                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                S.no
                              </th>

                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Items
                              </th>
                              {invoiceSettings.itemmrp ? (
                                <th
                                  style={{
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  MRP
                                </th>
                              ) : null}
                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Rate
                              </th>
                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Qty
                              </th>
                              {invoiceSettings.itemdiscount ? (
                                <th
                                  style={{
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  Disc
                                </th>
                              ) : null}
                              {invoiceSettings.hsncode ? (
                                <th
                                  style={{
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  HSN
                                </th>
                              ) : null}
                              {invoiceSettings.itemleveltax ? (
                                <th
                                  style={{
                                    backgroundColor: invoiceSettings.color,
                                  }}
                                >
                                  Tax(%)
                                </th>
                              ) : null}
                              {shopDetails.shopType === "Mobile" &&
                                invoiceSettings.imei1imei2 && (
                                  <th
                                    style={{
                                      backgroundColor: invoiceSettings.color,
                                    }}
                                  >
                                    IMEI1/IMEI2
                                  </th>
                                )}
                              <th
                                style={{
                                  backgroundColor: invoiceSettings.color,
                                }}
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {products.map((data, i) => (
                              <>
                                {parseFloat(data.itemTotal) !== 0 && (
                                  <tr key={i}>
                                    <td>{i + 1}</td>

                                    <td
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "2px",
                                      }}
                                    >
                                      {" "}
                                      {invoiceSettings.variant ? (
                                        <>
                                          {data.productName}-
                                          {data.unitOfMeasurment}
                                        </>
                                      ) : (
                                        <>{data.productName}</>
                                      )}
                                    </td>
                                    {invoiceSettings.itemmrp ? (
                                      <td>
                                        {data.productMrp
                                          ? data.productMrp
                                          : "-"}
                                      </td>
                                    ) : null}
                                    <td> {parseFloat(data.productPrice)}</td>
                                    <td>{parseFloat(data.count)}</td>

                                    {invoiceSettings.itemdiscount ? (
                                      <td>
                                        {data.discountPrice
                                          ? data.discountPrice
                                          : "-"}
                                        {data.discountType === "percentage"
                                          ? "%"
                                          : ""}
                                      </td>
                                    ) : null}
                                    {invoiceSettings.hsncode ? (
                                      <td>
                                        {data.productHsnCode
                                          ? data.productHsnCode
                                          : "-"}
                                      </td>
                                    ) : null}
                                    {invoiceSettings.itemleveltax ? (
                                      <td>
                                        {data.totalTax
                                          ? parseFloat(data.totalTax)
                                          : data.tax
                                          ? parseFloat(data.tax)
                                          : "-"}
                                      </td>
                                    ) : null}
                                    {shopDetails.shopType === "Mobile" &&
                                    invoiceSettings.imei1imei2 ? (
                                      <td>
                                        {data?.imei1
                                          ? data?.imei1
                                          : data?.imei2
                                          ? data?.imei2
                                          : "-"}
                                      </td>
                                    ) : null}

                                    <td>
                                      {data.itemTotal
                                        ? parseFloat(data.itemTotal).toFixed(2)
                                        : parseFloat(data.productPrice) *
                                          parseFloat(data.count)}
                                    </td>
                                  </tr>
                                )}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <hr style={{ border: "0.5px solid #000000" }} />
                      <div
                        className="Classic-Body-bot"
                        style={{ fontSize: invoiceSettings.A4fontsize }}
                      >
                        <div className="Classic-body-bot-left">
                          <div className="Classic-body-bot-left-content">
                            {!!(
                              invoiceSettings.notes && billInput.notes !== ""
                            ) &&
                              billInput.notes !== undefined && (
                                <div style={{ display: "flex" }}>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    <b>Notes: </b>
                                    <div
                                      style={{
                                        overflowWrap: "break-word",
                                      }}
                                    >
                                      {billInput.notes}
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>

                          {invoiceSettings.paymenyterms ? (
                            <div>
                              {invoiceSettings.paymentTermsField !== "" ? (
                                <div className="Classic-body-bot-left-content">
                                  <div style={{ fontWeight: 600 }}>
                                    Payment Terms:
                                  </div>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    {invoiceSettings.paymentTermsField}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          ) : null}

                          {/* {invoiceSettings.invoiceprefix ? (
                          <div>
                            {invoiceSettings.invoicePrefixtext !== "" ? (
                              <div className="Classic-body-bot-left-content">
                                <div>
                                  <strong>Invoice-Prefix: </strong>
                                   {result.invoicePrefixField}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null} */}
                          {invoiceSettings.termscondition ? (
                            <div>
                              {invoiceSettings.tAndCField !== "" ? (
                                <div className="Classic-body-bot-left-content">
                                  <div>
                                    <strong>Terms and Conditions:</strong>
                                  </div>
                                  <div style={{ overflowWrap: "break-word" }}>
                                    {invoiceSettings.tAndCField}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                        <div className="Classic-body-bot-right">
                          <div className="Modern-body-bot-righ-top">
                            <div>
                              <div
                                style={{
                                  marginLeft: "70px",
                                  textAlign: "left",

                                  // width: "52%",
                                  // marginLeft: "2px",
                                  paddingLeft: "25px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                    color: "black",
                                  }}
                                >
                                  <span>SUB Total</span>
                                  <span>
                                    {currencyFormatter(result.billSubTotal)}
                                  </span>
                                </div>
                                {data.loyaltyDiscount > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                      color: "black",
                                    }}
                                  >
                                    {/* <span>Items: {products.length}</span> */}
                                    <span>Loyalty Discount</span>
                                    <span>
                                      -{currencyFormatter(data.loyaltyDiscount)}
                                    </span>
                                  </div>
                                )}
                                {Boolean(
                                  invoiceSettings.roundOff &&
                                    Math.abs(result.roundOffAmount) > 0
                                ) && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "2px 0",
                                        color: "black",
                                      }}
                                    >
                                      <span>Round Off</span>
                                      <span>
                                        {currencyFormatter(
                                          result.roundOffAmount
                                        )}
                                      </span>
                                    </div>
                                  </>
                                )}
                                {Boolean(
                                  invoiceSettings.adddiscount &&
                                    billInput.billDiscount
                                ) && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "2px 0",
                                        color: "black",
                                      }}
                                    >
                                      <span>Discount(Flat)</span>
                                      <span>
                                        {country.CurrencySymbol}
                                        {discountType.billDiscountType ===
                                        "flat"
                                          ? billInput.billDiscount
                                            ? billInput.billDiscount
                                            : "0"
                                          : discountType.billDiscountType ===
                                            "percentage"
                                          ? parseFloat(
                                              (result.billSubTotal *
                                                billInput.billDiscount) /
                                                100
                                            ).toFixed(1)
                                          : 0}
                                      </span>
                                    </div>
                                  </>
                                )}
                                {Object.keys(couponObj).length > 0 && (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "2px 0",
                                        color: "black",
                                      }}
                                    >
                                      <span>COUPON DISC</span>
                                      <span>
                                        {parseFloat(
                                          result.couponDiscountAmount
                                        ).toFixed(2)}
                                      </span>
                                    </div>
                                  </>
                                )}
                                {invoiceSettings.othercharges &&
                                  settings.otherChargesField?.length > 0 &&
                                  settings?.otherChargesField?.map((data) => {
                                    if (parseFloat(data.price)) {
                                      return (
                                        <div key={data.id}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              padding: "2px 0",
                                              color: "black",
                                            }}
                                            key={data.id}
                                          >
                                            <div>
                                              Other charges(
                                              {data.name
                                                .charAt(0)
                                                .toUpperCase() +
                                                data.name.slice(1)}
                                              )
                                            </div>
                                            <div>
                                              {data.price
                                                ? currencyFormatter(data.price)
                                                : ""}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    }
                                  })}
                                {customerDetails.customerPhoneNumber !== "" &&
                                  customerDetails.customerPhoneNumber !==
                                    "NA" &&
                                  invoiceSettings.customerprivacy && (
                                    <div>
                                      {invoiceSettings.customerprivacy && (
                                        <div>
                                          {Object.keys(loyaltyObj).length >
                                            0 && (
                                            <>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent:
                                                    "space-between",
                                                  alignItems: "center",
                                                  padding: "2px 0",
                                                  color: "black",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    overflowWrap: "break-word",
                                                  }}
                                                >
                                                  {" "}
                                                  Loyalty Discount(Points)
                                                </span>
                                                <span
                                                  style={{
                                                    overflowWrap: "break-word",
                                                  }}
                                                >
                                                  {
                                                    loyaltyObj.minLoyaltyPointsReq
                                                  }
                                                </span>
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  )}
                                <hr
                                  style={{
                                    border: "1px solid rgb(63, 63, 63)",
                                  }}
                                />
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                    fontWeight: "600",
                                    color: "black",
                                  }}
                                >
                                  <span style={{ fontWeight: "600" }}>
                                    Total Amount
                                  </span>
                                  <span style={{ fontWeight: "600" }}>
                                    {currencyFormatter(result.billFinalTotal)}
                                  </span>
                                </div>
                                {invoiceSettings.itemmrp && (
                                  <div>
                                    {calculateAmountSaved(products) > 0 && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          padding: "2px 0",
                                          color: "black",
                                        }}
                                      >
                                        <div style={{ fontWeight: "600" }}>
                                          Saved Amount
                                        </div>
                                        <div
                                          style={{
                                            fontWeight: "600",
                                            fontSize: 18,
                                          }}
                                        >
                                          {currencyFormatter(
                                            calculateAmountSaved(products)
                                          )}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    padding: "2px 0",
                                    color: "black",
                                  }}
                                >
                                  <div>Amount Paid:</div>
                                  <div>
                                    {currencyFormatter(billInput.billPaid)}
                                  </div>
                                </div>

                                <hr
                                  style={{
                                    border: "1px solid rgb(63, 63, 63)",
                                  }}
                                />
                                {billInput.billAmountDue < 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                      color: "black",
                                    }}
                                  >
                                    <div>Balance Amount:</div>
                                    <div>
                                      {currencyFormatter(
                                        Math.abs(billInput.billAmountDue)
                                      )}
                                    </div>
                                  </div>
                                )}
                                {billInput.billAmountDue > 0 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      padding: "2px 0",
                                      color: "black",
                                    }}
                                  >
                                    <div>Amount Due:</div>
                                    <div>
                                      <strong>
                                        {currencyFormatter(
                                          Math.abs(billInput.billAmountDue)
                                        )}
                                      </strong>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>

                          <hr
                            style={{
                              marginLeft: "76px",

                              bordertop: "2px solid",
                            }}
                          />
                          <div className="Classic-body-bot-righ-bot">
                            <div
                              style={{
                                display: "flex",
                                gap: "5px",
                                color: "black",
                              }}
                            >
                              <div>
                                <strong>Total in Words:</strong>
                              </div>
                              <div>{inWords(result.billFinalTotal)}Only</div>
                            </div>

                            {shopDetails.loyaltyPackage === "yes" &&
                              customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" &&
                              invoiceSettings.customerprivacy && (
                                <div style={{ display: "flex" }}>
                                  <div>Available Loyalty Pts:</div>
                                  <div>
                                    {loyaltyObj.minLoyaltyPointsReq
                                      ? (
                                          parseFloat(
                                            getUpdatedLoyaltyPoints(
                                              result.billFinalTotal,
                                              loyaltyPoints ? loyaltyPoints : 0
                                            )
                                          ) -
                                          parseFloat(
                                            loyaltyObj.minLoyaltyPointsReq
                                          )
                                        ).toFixed(2)
                                      : getUpdatedLoyaltyPoints(
                                          result.billFinalTotal,
                                          loyaltyPoints ? loyaltyPoints : 0
                                        ).toFixed(2)}
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style={{ width: "50%" }}>
                      {invoiceSettings.itemleveltax &&
                        productTaxCalc?.data?.length > 0 && (
                          <div style={{}}>
                            <div
                              class="table-row header"
                              style={{ border: "none" }}
                            >
                              <div
                                style={{
                                  textAlign: "left",
                                }}
                                className="num-80"
                              >
                                Desc
                              </div>
                              <div
                                style={{
                                  textAlign: "left",
                                }}
                                className="taxable"
                              >
                                Taxable
                              </div>
                              {productTaxCalc?.head.map((head, i) => (
                                <div
                                  style={{
                                    textAlign: "left",
                                    textTransform: "capitalize",
                                  }}
                                  className="num-80"
                                >
                                  {head === "additionalcess" ? "Ad.Cess" : head}
                                </div>
                              ))}
                            </div>
                            {productTaxCalc?.data?.map((data, i) => (
                              <div
                                key={i}
                                className="table-row"
                                style={{ border: "none" }}
                              >
                                {/* <div
                                className="dash"
                                style={{
                                  margin: "4px 0",
                                }}
                              /> */}
                                <div
                                  style={{
                                    textAlign: "left",
                                  }}
                                  className="num-80"
                                >
                                  {data.taxPercentage
                                    ? parseFloat(data.taxPercentage).toFixed(1)
                                    : 0.0}
                                  %
                                </div>
                                <div
                                  className="taxable"
                                  style={{ textAlign: "left" }}
                                >
                                  {parseFloat(data.taxableValue).toFixed(2)}
                                </div>
                                {productTaxCalc?.head.map((head, i) => (
                                  <div
                                    style={{
                                      textAlign: "left",
                                      textTransform: "capitalize",
                                    }}
                                    className="num-80"
                                  >
                                    {data[head]
                                      ? parseFloat(data[head]).toFixed(2)
                                      : "-"}
                                  </div>
                                ))}
                              </div>
                            ))}
                          </div>
                        )}
                    </div>
                    {invoiceSettings.ghoshaklogo && (
                      <div
                        className="Classic-footer-A4"
                        style={{
                          width: "auto",
                          marginLeft: "45px",
                          marginRight: "45px",
                          fontSize: "10PX",
                        }}
                      >
                        <div
                          style={{
                            width: "400",
                            backgroundColor: invoiceSettings.color,
                            display: "flex",
                            height: "40px",
                          }}
                        >
                          <div className="Classic-footer-A4-fooert-content">
                            Generate professional invoice using
                          </div>
                          <div className="Classic-footer-A4-fooert-content-1">
                            <img
                              src={Logo_Original}
                              style={{ height: "20px", width: "auto" }}
                            />
                          </div>
                          <div className="Classic-footer-A4-fooert-content-2">
                            Business app
                          </div>
                          <div className="Classic-footer-A4-fooert-content-3">
                            <img
                              src={Google}
                              style={{
                                height: "20px",
                                width: "auto",
                                marginLeft: "4px",
                                marginTop: "11px",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (A4design === "Tabular") {
      return (
        <div>
          <div
            style={{
              height: "auto",
              display: "none",
              color: "black",
            }}
          >
            <div
              id="divToPrint"
              ref={ref}
              style={{
                background: "white",
                padding: "15px",
                paddingInline: 50,
                fontSize: invoiceSettings.A4fontsize,
                fontFamily: invoiceSettings.A4Fonttype,
              }}
            >
              <div style={{ width: "100%" }}>
                <div style={{ width: "100%" }}>
                  <div style={{ display: "flex" }}>
                    <div style={{ width: "75%" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        {invoiceSettings.shoplogo && (
                          <div>
                            {shopDetails.shopIconLocation !== "removed" &&
                              " " && (
                                <img
                                  src={shopDetails.shopIconLocation}
                                  alt="shop icon"
                                  style={{
                                    width: "100px",
                                    height: "100px",
                                    paddingLeft: "5px",
                                    borderRadius: "6px",
                                  }}
                                />
                              )}
                          </div>
                        )}
                        <div
                          style={{
                            padding: "0px 0px 0px 10px",
                            fontSize: "22px",
                            color: invoiceSettings.color,
                            textAlign: "left",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            lineHeight: "24px",
                          }}
                        >
                          {shopDetails.shopName}
                        </div>
                      </div>
                    </div>
                    <div style={{ width: "25%" }}>
                      <div
                        style={{
                          fontSize: "18px",
                          color: "black",
                          fontWeight: "600",
                          paddingTop: "48px",
                        }}
                      >
                        TAX INVOICE
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      border: "1.5px solid black",
                      marginTop: "5px",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            width: "50%",
                            borderRight: "1.5px solid black",
                          }}
                        >
                          <div
                            style={{
                              borderBottom: "1.5px solid black",
                              padding: "5px",
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <div
                                style={{
                                  width: "100%",
                                  fontWeight: "600",
                                  color: "black",
                                }}
                              >
                                {shopDetails.shopName}
                              </div>
                            </div>
                            <div style={{ width: "100%" }}>
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    width: "33.33%",
                                    fontWeight: "600",
                                    color: "black",
                                  }}
                                >
                                  Head Office:
                                </div>
                                <div
                                  style={{ width: "66.67%", color: "black" }}
                                >
                                  {invoiceSettings.ShopAddress && (
                                    <div> {shopDetails.shopAddress}</div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style={{ padding: "5px" }}>
                            <div style={{ width: "100%" }}>
                              {" "}
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    width: "33.33%",
                                    fontWeight: "600",
                                    color: "black",
                                  }}
                                >
                                  Branch Office:
                                </div>
                                <div
                                  style={{ width: "66.67%", color: "black" }}
                                >
                                  {invoiceSettings.ShopAddress && (
                                    <div> {shopDetails.shopAddress}</div>
                                  )}
                                  <div
                                    style={{
                                      fontWeight: "600",
                                      marginTop: "20px",
                                      display: "flex",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "33.33%",
                                        color: "black",
                                      }}
                                    >
                                      PHONE :
                                    </div>
                                    <div
                                      style={{
                                        width: "66.67%",
                                        color: "black",
                                      }}
                                    >
                                      {shopDetails.websiteContactPhoneNumber
                                        ? shopDetails.websiteContactPhoneNumber
                                        : shopDetails.shopPhoneNumber}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div style={{ width: "50%" }}>
                          <div style={{ borderBottom: "1.5px solid black" }}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  width: "50%",
                                  borderRight: "1.5px solid black",
                                  padding: "10px",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    Invoice No
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  padding: "10px",
                                  color: "black",
                                }}
                              >
                                {invoiceSettings.invoiceprefix && (
                                  <span>{result.invoicePrefixField}</span>
                                )}
                                {result.invoiceNumber}
                              </div>
                            </div>
                          </div>
                          <div style={{ borderBottom: "1.5px solid black" }}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  width: "50%",
                                  borderRight: "1.5px solid black",
                                  padding: "10px",
                                  color: "black",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    Invoice Date
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  padding: "10px",
                                  color: "black",
                                }}
                              >
                                {new Date().toISOString().substring(0, 10)}
                              </div>
                            </div>
                          </div>
                          <div style={{ borderBottom: "1.5px solid black" }}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  width: "50%",
                                  borderRight: "1.5px solid black",
                                  padding: "10px",
                                }}
                              >
                                <div
                                  style={{ display: "flex", color: "black" }}
                                >
                                  <div style={{ width: "91.67%" }}>
                                    {" "}
                                    Customer ID
                                  </div>
                                  <div style={{ width: "8.33%" }}>:</div>
                                </div>
                              </div>
                              <div
                                style={{ width: "50%", padding: "10px" }}
                              ></div>
                            </div>
                          </div>
                          <div>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  width: "50%",
                                  borderRight: "1.5px solid black",
                                  padding: "10px",
                                }}
                              >
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    {" "}
                                    Billing Period
                                  </div>
                                  <div style={{ width: "8.33%" }}>:</div>
                                </div>
                              </div>
                              <div
                                style={{ width: "50%", padding: "10px" }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          borderTop: "1.5px solid black",
                          padding: "8px",
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <div style={{ width: "50%" }}>
                            <div style={{ display: "flex", color: "black" }}>
                              {invoiceSettings.customerprivacy &&
                                invoiceSettings.deliveryaddress && (
                                  <>
                                    {((customerDetails.customerName !== "" &&
                                      customerDetails.customerName !== "NA") ||
                                      (data.deliveryAddress !== "" &&
                                        data.deliveryAddress !== "NA")) && (
                                      <div style={{ width: "29.17%" }}>
                                        Customer Details:
                                      </div>
                                    )}
                                  </>
                                )}
                              <div style={{ width: "70.83%" }}>
                                <div>
                                  {" "}
                                  {invoiceSettings.customerprivacy && (
                                    <div>
                                      {customerDetails.customerName !== "" &&
                                        customerDetails.customerName !==
                                          "NA" && (
                                          <div
                                            style={{
                                              whiteSpace: "nowrap",
                                              color: "black",
                                            }}
                                          >
                                            {customerDetails.customerName}
                                          </div>
                                        )}
                                    </div>
                                  )}
                                </div>
                                {invoiceSettings.deliveryaddress && (
                                  <>
                                    {data.deliveryAddress !== "" &&
                                    data.deliveryAddress !== "NA" ? (
                                      <div style={{ color: "black" }}>
                                        {data.deliveryAddress}
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                          <div style={{ width: "50%" }}>
                            {invoiceSettings.customerprivacy && (
                              <div style={{ display: "flex" }}>
                                {customerDetails.customerName !== "" &&
                                  customerDetails.customerName !== "NA" && (
                                    <>
                                      <div
                                        style={{
                                          width: "50%",
                                          textAlign: "center",
                                          color: "black",
                                        }}
                                      >
                                        Phone No :
                                      </div>
                                      <div
                                        style={{ width: "50%", color: "black" }}
                                      >
                                        {customerDetails.customerPhoneNumber}
                                      </div>
                                    </>
                                  )}
                              </div>
                            )}
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "center",
                                  color: "black",
                                }}
                              >
                                GSTIN No :
                              </div>
                              <div style={{ width: "50%" }}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <table
                        id="invoiceTabular"
                        style={{
                          width: "100%",
                          border: "1px solid black",
                          color: "black",
                        }}
                      >
                        <thead
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          <tr
                            style={{
                              textAlign: "center",
                              border: "1px solid black",
                            }}
                          >
                            <th
                              style={{
                                border: "1px solid black",
                                fontWeight: "500",
                              }}
                            >
                              S.no
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                fontWeight: "500",
                              }}
                            >
                              Items
                            </th>

                            {invoiceSettings.itemmrp ? (
                              <th
                                style={{
                                  border: "1px solid black",
                                  fontWeight: "500",
                                }}
                              >
                                MRP
                              </th>
                            ) : null}
                            <th
                              style={{
                                border: "1px solid black",
                                fontWeight: "500",
                              }}
                            >
                              Rate
                            </th>
                            <th
                              style={{
                                border: "1px solid black",
                                fontWeight: "500",
                              }}
                            >
                              Qty
                            </th>
                            {invoiceSettings.itemdiscount ? (
                              <th
                                style={{
                                  border: "1px solid black",
                                  fontWeight: "500",
                                }}
                              >
                                Disc
                              </th>
                            ) : null}
                            {invoiceSettings.hsncode ? (
                              <th
                                style={{
                                  border: "1px solid black",
                                  fontWeight: "500",
                                }}
                              >
                                HSN
                              </th>
                            ) : null}
                            {invoiceSettings.itemleveltax ? (
                              <th
                                style={{
                                  border: "1px solid black",
                                  fontWeight: "500",
                                }}
                              >
                                Tax(%)
                              </th>
                            ) : null}
                            {shopDetails.shopType === "Mobile" &&
                            invoiceSettings.imei1imei2 ? (
                              <th
                                style={{
                                  border: "1px solid black",
                                  fontWeight: "500",
                                }}
                              >
                                IMEI1/IMEI2
                              </th>
                            ) : null}

                            <th
                              style={{
                                border: "1px solid black",
                                fontWeight: "500",
                              }}
                            >
                              Amount
                            </th>
                          </tr>
                        </thead>
                        <tbody
                          style={{
                            border: "1px solid black",
                          }}
                        >
                          {products.map((data, i) => (
                            <>
                              {parseFloat(data.itemTotal) !== 0 && (
                                <tr
                                  key={i}
                                  style={{ backgroundColor: "white" }}
                                >
                                  <td>{i + 1}</td>

                                  <td style={{ textAlign: "left" }}>
                                    {" "}
                                    {invoiceSettings.variant ? (
                                      <>
                                        {data.productName}-
                                        {data.unitOfMeasurment}
                                      </>
                                    ) : (
                                      <>{data.productName}</>
                                    )}{" "}
                                  </td>
                                  {invoiceSettings.itemmrp ? (
                                    <td>
                                      {" "}
                                      {data.productMrp
                                        ? data.productMrp
                                        : "-"}{" "}
                                    </td>
                                  ) : null}
                                  <td> {parseFloat(data.productPrice)}</td>
                                  <td>{parseFloat(data.count)}</td>

                                  {invoiceSettings.itemdiscount ? (
                                    <td>
                                      {data.discountPrice
                                        ? data.discountPrice
                                        : "-"}
                                      {data.discountType === "percentage"
                                        ? "%"
                                        : ""}
                                    </td>
                                  ) : null}
                                  {invoiceSettings.hsncode ? (
                                    <td>
                                      {data.productHsnCode
                                        ? data.productHsnCode
                                        : "-"}
                                    </td>
                                  ) : null}
                                  {invoiceSettings.itemleveltax ? (
                                    <td>
                                      {" "}
                                      {data.totalTax
                                        ? parseFloat(data.totalTax)
                                        : data.tax
                                        ? parseFloat(data.tax)
                                        : "-"}
                                    </td>
                                  ) : null}
                                  {shopDetails.shopType === "Mobile" &&
                                  invoiceSettings.imei1imei2 ? (
                                    <td>
                                      {data?.imei1
                                        ? data?.imei1
                                        : data?.imei2
                                        ? data?.imei2
                                        : "-"}
                                    </td>
                                  ) : null}

                                  <td>
                                    {data.itemTotal
                                      ? parseFloat(data.itemTotal).toFixed(2)
                                      : parseFloat(data.productPrice) *
                                        parseFloat(data.count)}
                                  </td>
                                </tr>
                              )}
                            </>
                          ))}
                        </tbody>
                      </table>
                      <div style={{ display: "flex" }}>
                        {/* testtestets */}
                        <div sryle={{ width: "50%", color: "black" }}>
                          {invoiceSettings.itemleveltax &&
                            productTaxCalc?.data?.length > 0 && (
                              <div style={{ padding: "10px" }}>
                                <div
                                  class="table-row header"
                                  style={{ border: "none", color: "black" }}
                                >
                                  <div
                                    style={{
                                      textAlign: "left",
                                    }}
                                    className="num-80"
                                  >
                                    Desc
                                  </div>
                                  <div
                                    style={{
                                      textAlign: "left",
                                      color: "black",
                                    }}
                                    className="taxable"
                                  >
                                    Taxable
                                  </div>
                                  {productTaxCalc?.head.map((head, i) => (
                                    <div
                                      style={{
                                        textAlign: "left",
                                        textTransform: "capitalize",
                                        color: "black",
                                      }}
                                      className="num-80"
                                    >
                                      {head === "additionalcess"
                                        ? "Ad.Cess"
                                        : head}
                                    </div>
                                  ))}
                                </div>
                                {productTaxCalc?.data?.map((data, i) => (
                                  <div
                                    key={i}
                                    className="table-row"
                                    style={{ border: "none" }}
                                  >
                                    {/* <div
                                className="dash"
                                style={{
                                  margin: "4px 0",
                                }}
                              /> */}
                                    <div
                                      style={{
                                        textAlign: "left",
                                      }}
                                      className="num-80"
                                    >
                                      {data.taxPercentage
                                        ? parseFloat(
                                            data.taxPercentage
                                          ).toFixed(1)
                                        : 0.0}
                                      %
                                    </div>
                                    <div
                                      className="taxable"
                                      style={{ textAlign: "left" }}
                                    >
                                      {parseFloat(data.taxableValue).toFixed(2)}
                                    </div>
                                    {productTaxCalc?.head.map((head, i) => (
                                      <div
                                        style={{
                                          textAlign: "left",
                                          textTransform: "capitalize",
                                        }}
                                        className="num-80"
                                      >
                                        {data[head]
                                          ? parseFloat(data[head]).toFixed(2)
                                          : "-"}
                                      </div>
                                    ))}
                                  </div>
                                ))}
                              </div>
                            )}
                        </div>
                        <div
                          style={{
                            width: "50%",
                            marginLeft: "auto",
                            padding: "10px",
                            fontWeight: "600",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "50%" }}>
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{ width: "91.67%", color: "black" }}
                                >
                                  SUB Total
                                </div>
                                <div style={{ width: "8.33%", color: "black" }}>
                                  :
                                </div>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "50%",
                                textAlign: "right",
                                color: "black",
                              }}
                            >
                              {currencyFormatter(result.billSubTotal)}
                            </div>
                          </div>
                          {data.loyaltyDiscount > 0 && (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    Loyalty Discount
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                -{currencyFormatter(data.loyaltyDiscount)}
                              </div>
                            </div>
                          )}
                          {Boolean(
                            invoiceSettings.roundOff &&
                              Math.abs(result.roundOffAmount) > 0
                          ) && (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    Round Off
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                {currencyFormatter(result.roundOffAmount)}
                              </div>
                            </div>
                          )}
                          {Boolean(
                            invoiceSettings.adddiscount &&
                              billInput.billDiscount
                          ) && (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    Discount(Flat)
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                {country.CurrencySymbol}
                                {discountType.billDiscountType === "flat"
                                  ? billInput.billDiscount
                                    ? billInput.billDiscount
                                    : "0"
                                  : discountType.billDiscountType ===
                                    "percentage"
                                  ? parseFloat(
                                      (result.billSubTotal *
                                        billInput.billDiscount) /
                                        100
                                    ).toFixed(1)
                                  : 0}
                              </div>
                            </div>
                          )}
                          {Object.keys(couponObj).length > 0 && (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    COUPON DISC
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                {parseFloat(
                                  result.couponDiscountAmount
                                ).toFixed(2)}
                              </div>
                            </div>
                          )}
                          {invoiceSettings.othercharges &&
                            settings.otherChargesField?.length > 0 &&
                            settings?.otherChargesField?.map((data) => {
                              if (parseFloat(data.price)) {
                                return (
                                  <div
                                    style={{ display: "flex", color: "black" }}
                                    key={data.id}
                                  >
                                    <div style={{ width: "50%" }} key={data.id}>
                                      <div style={{ display: "flex" }}>
                                        <div style={{ width: "91.67%" }}>
                                          {" "}
                                          Other charges(
                                          {data.name.charAt(0).toUpperCase() +
                                            data.name.slice(1)}
                                          )
                                        </div>
                                        <div
                                          style={{
                                            width: "8.33%",
                                            color: "black",
                                          }}
                                        >
                                          :
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: "50%",
                                        textAlign: "right",
                                        color: "black",
                                      }}
                                    >
                                      {data.price
                                        ? currencyFormatter(data.price)
                                        : ""}
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          {customerDetails.customerPhoneNumber !== "" &&
                            customerDetails.customerPhoneNumber !== "NA" && (
                              <div>
                                {/* {invoiceSettings.customerprivacy && ( */}
                                <div>
                                  {Object.keys(loyaltyObj).length > 0 && (
                                    <div style={{ display: "flex" }}>
                                      <div style={{ width: "50%" }}>
                                        <div style={{ display: "flex" }}>
                                          <div
                                            style={{
                                              width: "91.67%",
                                              color: "black",
                                            }}
                                          >
                                            {" "}
                                            Loyalty Discount(Points)
                                          </div>
                                          <div
                                            style={{
                                              width: "8.33%",
                                              color: "black",
                                            }}
                                          >
                                            :
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          width: "50%",
                                          textAlign: "right",
                                          color: "black",
                                        }}
                                      >
                                        {loyaltyObj.minLoyaltyPointsReq}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                        </div>
                      </div>

                      {/* testtest22 */}
                      <div
                        style={{
                          padding: "10px",
                          borderTop: "1px solid black",
                          borderBottom: "1px solid black",
                        }}
                      >
                        {" "}
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <div style={{ width: "50%" }}>
                            <div style={{ width: "100%", color: "black" }}>
                              {" "}
                              Rupees.{inWords(result.billFinalTotal)} -only
                            </div>
                            <div style={{ width: "100%" }}>
                              <div style={{ display: "flex" }}>
                                <div
                                  style={{
                                    width: "50%",
                                    fontWeight: "600",
                                    color: "black",
                                  }}
                                >
                                  {" "}
                                  Payment Mode:
                                </div>
                                <div style={{ width: "50%", color: "black" }}>
                                  {paymentMethodGenerator(data.paymentMethod)}
                                </div>
                              </div>
                            </div>
                            {/* {shopDetails.shopType === "Restaurant" && (
                              <div style={{ width: "100%" }}>
                                <div style={{ display: "flex" }}>
                                  <div style={{ width: "50%", color: "black" }}>
                                    {paymentMethodGenerator(data.paymentMethod)}
                                  </div>
                                </div>
                              </div>
                            )} */}
                          </div>
                          <div style={{ width: "50%" }}>
                            <div style={{ display: "flex", fontWeight: "600" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{
                                      width: "91.67%",
                                      paddingLeft: "10px",
                                      color: "black",
                                    }}
                                  >
                                    Total
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                {currencyFormatter(result.billFinalTotal)}
                              </div>
                            </div>
                            {invoiceSettings.itemmrp && (
                              <div
                                style={{
                                  display: "flex",
                                  fontWeight: "600",
                                  color: "black",
                                }}
                              >
                                {calculateAmountSaved(products) > 0 && (
                                  <>
                                    <div style={{ width: "50%" }}>
                                      <div style={{ display: "flex" }}>
                                        <div
                                          style={{
                                            width: "91.67%",
                                            paddingLeft: "10px",
                                            color: "black",
                                          }}
                                        >
                                          Saved Amount
                                        </div>
                                        <div
                                          style={{
                                            width: "8.33%",
                                            color: "black",
                                          }}
                                        >
                                          :
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      style={{
                                        width: "50%",
                                        textAlign: "right",
                                        color: "black",
                                      }}
                                    >
                                      {currencyFormatter(
                                        calculateAmountSaved(products)
                                      )}
                                    </div>
                                  </>
                                )}
                              </div>
                            )}
                            <div style={{ display: "flex", fontWeight: "600" }}>
                              <div style={{ width: "50%" }}>
                                <div
                                  style={{ display: "flex", color: "black" }}
                                >
                                  <div
                                    style={{
                                      width: "91.67%",
                                      paddingLeft: "10px",
                                      color: "black",
                                    }}
                                  >
                                    Amount Paid
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div
                                style={{
                                  width: "50%",
                                  textAlign: "right",
                                  color: "black",
                                }}
                              >
                                {currencyFormatter(billInput.billPaid)}
                              </div>
                            </div>

                            {billInput.billAmountDue < 0 && (
                              <div
                                style={{ display: "flex", fontWeight: "600" }}
                              >
                                <div style={{ width: "50%" }}>
                                  <div style={{ display: "flex" }}>
                                    <div
                                      style={{
                                        width: "91.67%",
                                        paddingLeft: "10px",
                                        color: "black",
                                      }}
                                    >
                                      Balance Amount:
                                    </div>
                                    <div
                                      style={{ width: "8.33%", color: "black" }}
                                    >
                                      :
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "50%",
                                    textAlign: "right",
                                    color: "black",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </div>
                              </div>
                            )}

                            {billInput.billAmountDue > 0 && (
                              <div
                                style={{ display: "flex", fontWeight: "600" }}
                              >
                                <div style={{ width: "50%" }}>
                                  <div style={{ display: "flex" }}>
                                    <div
                                      style={{
                                        width: "91.67%",
                                        paddingLeft: "10px",
                                        color: "black",
                                      }}
                                    >
                                      Amount Due
                                    </div>
                                    <div
                                      style={{ width: "8.33%", color: "black" }}
                                    >
                                      :
                                    </div>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    width: "50%",
                                    textAlign: "right",
                                    color: "black",
                                  }}
                                >
                                  {currencyFormatter(
                                    Math.abs(billInput.billAmountDue)
                                  )}
                                </div>
                              </div>
                            )}
                            {shopDetails.loyaltyPackage === "yes" &&
                              customerDetails.customerPhoneNumber !== "" &&
                              customerDetails.customerPhoneNumber !== "NA" && (
                                <div
                                  style={{ display: "flex", fontWeight: "600" }}
                                >
                                  <div style={{ width: "50%" }}>
                                    <div style={{ display: "flex" }}>
                                      <div
                                        style={{
                                          width: "91.67%",
                                          paddingLeft: "10px",
                                          color: "black",
                                        }}
                                      >
                                        Available Loyalty Pts:
                                      </div>
                                      <div
                                        style={{
                                          width: "8.33%",
                                          color: "black",
                                        }}
                                      >
                                        :
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      width: "50%",
                                      textAlign: "right",
                                      color: "black",
                                    }}
                                  >
                                    {loyaltyObj.minLoyaltyPointsReq
                                      ? (
                                          parseFloat(
                                            getUpdatedLoyaltyPoints(
                                              result.billFinalTotal,
                                              loyaltyPoints ? loyaltyPoints : 0
                                            )
                                          ) -
                                          parseFloat(
                                            loyaltyObj.minLoyaltyPointsReq
                                          )
                                        ).toFixed(2)
                                      : getUpdatedLoyaltyPoints(
                                          result.billFinalTotal,
                                          loyaltyPoints ? loyaltyPoints : 0
                                        ).toFixed(2)}
                                  </div>
                                </div>
                              )}
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            width: "50%",
                            borderRight: "1px solid black",
                            padding: "10px",
                            fontWeight: "600",
                            color: "black",
                          }}
                        >
                          {shopDetails.shopGST && (
                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div style={{ width: "75%", color: "black" }}>
                                    GSTIN NO
                                  </div>
                                  <div style={{ width: "25%", color: "black" }}>
                                    :
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "50%", color: "black" }}>
                                {shopDetails.shopGST}
                              </div>
                            </div>
                          )}
                          <div style={{ display: "flex" }}>
                            <div style={{ width: "50%" }}>
                              {" "}
                              <div style={{ display: "flex" }}>
                                <div style={{ width: "75%", color: "black" }}>
                                  PAN NO
                                </div>
                                <div style={{ width: "25%", color: "black" }}>
                                  :
                                </div>
                              </div>
                            </div>
                            <div style={{ width: "50%" }}></div>
                          </div>
                        </div>
                        {shopDetails.accountDetails && (
                          <div
                            style={{
                              width: "50%",
                              padding: "5px",
                              fontWeight: "600",
                              color: "black",
                            }}
                          >
                            <div
                              style={{
                                textDecoration: "underline",
                                color: "black",
                              }}
                            >
                              Account Details:
                            </div>

                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    A/C Name{" "}
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "50%", color: "black" }}>
                                {" "}
                                {shopDetails.accountDetails.beneficiaryName}
                              </div>
                            </div>

                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    A/C NO{" "}
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>
                              <div style={{ width: "50%", color: "black" }}>
                                {" "}
                                {shopDetails.accountDetails.accountNumber}
                              </div>
                            </div>

                            <div style={{ display: "flex" }}>
                              <div style={{ width: "50%" }}>
                                <div style={{ display: "flex" }}>
                                  <div
                                    style={{ width: "91.67%", color: "black" }}
                                  >
                                    IFSC{" "}
                                  </div>
                                  <div
                                    style={{ width: "8.33%", color: "black" }}
                                  >
                                    :
                                  </div>
                                </div>
                              </div>

                              <div style={{ width: "50%", color: "black" }}>
                                {shopDetails.accountDetails.ifsc}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          borderTop: "1px solid black",
                          borderRight: "1px solid black",
                        }}
                      >
                        <div
                          style={{
                            width: "50%",
                            borderRight: "1px solid black",
                          }}
                        >
                          {invoiceSettings.notes && (
                            <div style={{ padding: "5px" }}>
                              {billInput.notes !== "" &&
                                billInput.notes !== undefined && (
                                  <>
                                    <div style={{ width: "100%" }}>
                                      <div
                                        style={{
                                          fontWeight: "600",
                                          width: "100%",
                                          color: "black",
                                        }}
                                      >
                                        Declaration :
                                      </div>
                                    </div>
                                    <div style={{ width: "100%" }}>
                                      <div
                                        style={{
                                          width: "100%",
                                          color: "black",
                                        }}
                                      >
                                        {billInput.notes}
                                      </div>
                                    </div>
                                  </>
                                )}
                            </div>
                          )}
                        </div>
                        <div style={{ width: "50%", padding: "5px" }}>
                          <div
                            style={{ paddingBottom: "32px", display: "flex" }}
                          >
                            <div
                              style={{
                                marginLeft: "auto",
                                textAlign: "center",
                                width: "50%",
                                color: "black",
                              }}
                            >
                              For {shopDetails.shopName}
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div
                              style={{
                                marginLeft: "auto",
                                textAlign: "center",
                                width: "50%",
                                color: "black",
                              }}
                            >
                              Authoried Signatory
                            </div>
                          </div>
                        </div>
                      </div>
                      {invoiceSettings.termscondition && (
                        <>
                          {invoiceSettings.tAndCField !== "" && (
                            <div
                              style={{
                                display: "flex",
                                borderTop: "1px solid black",
                                padding: "10px",
                                color: "black",
                              }}
                            >
                              <div
                                style={{
                                  width: "100%",
                                  fontWeight: "600",
                                  color: "black",
                                }}
                              >
                                Terms & Conditions :
                              </div>
                              <div
                                style={{
                                  width: "100%",
                                  marginLeft: "20px",
                                  color: "black",
                                }}
                              >
                                {invoiceSettings.tAndCField}
                              </div>
                            </div>
                          )}
                        </>
                      )}
                      <div
                        style={{
                          display: "flex",
                          textAlign: "center",
                          borderTop: "1px solid black ",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            color: "black",
                          }}
                        >
                          {shopDetails.shopName}
                        </div>
                        <div style={{ width: "100%", color: "black" }}>
                          {invoiceSettings.ShopAddress && (
                            <div> {shopDetails.shopAddress}</div>
                          )}
                          {shopDetails.websiteUrl && (
                            <div>
                              {invoiceSettings.ShopURL && (
                                <div style={{ color: "black" }}>
                                  {" "}
                                  {shopDetails.customDomainUrl
                                    ? shopDetails.customDomainUrl
                                    : shopDetails.websiteUrl}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {invoiceSettings.ghoshaklogo && (
                        <div
                          className="Classic-footer-A4"
                          style={{
                            width: "auto",
                            marginLeft: "45px",
                            marginRight: "45px",
                            marginTop: "40px",
                            fontSize: "10PX",
                          }}
                        >
                          <div
                            style={{
                              width: "400",
                              backgroundColor: invoiceSettings.color,
                              display: "flex",
                              height: "40px",
                              color: "black",
                            }}
                          >
                            <div className="Classic-footer-A4-fooert-content">
                              Generate professional invoice using
                            </div>
                            <div className="Classic-footer-A4-fooert-content-1">
                              <img
                                src={Logo_Original}
                                style={{ height: "20px", width: "60px" }}
                              />
                            </div>
                            <div className="Classic-footer-A4-fooert-content-2">
                              Business app
                            </div>
                            <div className="Classic-footer-A4-fooert-content-3">
                              <img
                                src={Google}
                                style={{
                                  height: "20px",
                                  width: "60px",
                                  marginLeft: "4px",
                                  marginTop: "11px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {/* cofjknf */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
});
export default InvoiceTemplate;
